(() => {
  'use strict';
  const cardCache = new Map();
  const finishConfig = {
    stainless: {
      title: 'Stainless Steel',
      tag: 'stainless-door-sills',
      linkText: 'All Stainless Steel →',
      unavailable: 'Stainless Steel products are unavailable for this vehicle.',
    },
    matte: {
      title: 'Matte PRO',
      tag: 'matte-pro',
      linkText: 'All Matte PRO →',
      unavailable: 'Matte PRO products are unavailable for this vehicle.',
    },
  };
  const HONDA_ACCORD_GENERATION_ROUTES = Object.freeze([
    Object.freeze({
      key: 'honda-accord-ix-sedan', generation: 'IX sedan', years: '',
      label: 'Honda Accord IX sedan',
      note: 'Check the year and sedan body style on the product page before ordering.',
      exactProductIds: ['gid://shopify/Product/8642505900189', 'gid://shopify/Product/8641606877341'],
      exactHandles: [
        'honda-accord-ix-2013-2018-led-door-sills-illuminated-scuff-accord-logo-stainless-steel-entry-guards',
        'honda-accord-ix-2013-2018-custom-illuminated-entry-door-sill-protectors-with-logo-accord',
      ],
    }),
    Object.freeze({
      key: 'honda-accord-ix-coupe', generation: 'IX coupe', years: '',
      label: 'Honda Accord IX coupe',
      note: 'Check the year and coupe body style on the product page before ordering.',
      exactProductIds: ['gid://shopify/Product/8642505375901', 'gid://shopify/Product/8641483866269'],
      exactHandles: [
        'honda-accord-ix-coupe-2013-2018-led-door-sills-illuminated-scuff-accord-logo-stainless-steel-entry-guards',
        'honda-accord-ix-coupe-2013-2018-custom-illuminated-entry-door-sill-protectors-with-logo-accord',
      ],
    }),
    Object.freeze({
      key: 'honda-accord-x', generation: 'X', years: '',
      label: 'Honda Accord X',
      note: 'Check the year and body style on the product page before ordering.',
      exactProductIds: ['gid://shopify/Product/8642506064029', 'gid://shopify/Product/8641606779037'],
      exactHandles: [
        'honda-accord-x-2018-2023-led-door-sills-illuminated-scuff-accord-logo-stainless-steel-entry-guards',
        'honda-accord-x-2018-2023-custom-illuminated-entry-door-sill-protectors-with-logo-accord',
      ],
    }),
    Object.freeze({
      key: 'honda-accord-xi', generation: 'XI', years: '',
      label: 'Honda Accord XI',
      note: 'Check the finish, year and body style on the product page before ordering.',
      exactProductIds: ['gid://shopify/Product/8951264903325', 'gid://shopify/Product/9042261442717'],
      exactHandles: [
        'honda-accord-xi-2023-led-door-sills-illuminated-scuff-accord-logo-stainless-steel-entry-guards',
        'honda-accord-xi-2023-present-matte-pro-led-door-sills-accord-logo',
      ],
    }),
  ]);
  const HYUNDAI_TUCSON_GENERATION_ROUTES = Object.freeze([
    Object.freeze({
      key: 'hyundai-tucson-i-jm', generation: 'I / JM', years: '',
      label: 'Hyundai Tucson I / JM',
      note: 'Catalogue evidence identifies this pair as Tucson I / JM; confirm the vehicle details on the product page before ordering.',
      exactProductIds: ['gid://shopify/Product/8642507276445', 'gid://shopify/Product/8641505820829'],
      exactHandles: [
        'hyundai-tucson-i-2004-2015-led-door-sills-illuminated-scuff-tucson-logo-stainless-steel-entry-guards',
        'hyundai-tucson-i-2004-2015-custom-illuminated-entry-door-sill-protectors-with-logo-tucson',
      ],
    }),
    Object.freeze({
      key: 'hyundai-tucson-ii-tl', generation: 'TL', years: '',
      label: 'Hyundai Tucson TL',
      note: 'Catalogue evidence identifies this exact pair as Tucson TL; confirm the vehicle details on the product page before ordering.',
      exactProductIds: ['gid://shopify/Product/8642507407517', 'gid://shopify/Product/8641581219997'],
      exactHandles: [
        'hyundai-tucson-ii-2015-2020-led-door-sills-illuminated-scuff-tucson-logo-stainless-steel-entry-guards',
        'hyundai-tucson-ii-2015-2020-custom-illuminated-entry-door-sill-protectors-with-logo-tucson',
      ],
    }),
    Object.freeze({
      key: 'hyundai-tucson-nx4', generation: 'NX4', years: '',
      label: 'Hyundai Tucson NX4',
      note: 'Catalogue evidence identifies this exact pair as Tucson NX4; confirm the vehicle details on the product page before ordering.',
      exactProductIds: ['gid://shopify/Product/8641420918941', 'gid://shopify/Product/8641400537245'],
      exactHandles: [
        'hyundai-tucson-iv-led-door-sills-illuminated-scuff-tucson-logo-stainless-steel-entry-guards',
        'hyundai-tucson-iv-2020-custom-illuminated-entry-door-sill-protectors-with-logo-tucson',
      ],
    }),
  ]);
  const KIA_SORENTO_GENERATION_ROUTES = Object.freeze([
    Object.freeze({
      key: 'kia-sorento-bl', generation: 'BL', years: '',
      label: 'Kia Sorento BL',
      note: 'Catalogue evidence identifies this pair by the BL body code; confirm the vehicle details on the product page before ordering.',
      exactProductIds: ['gid://shopify/Product/8642501312669', 'gid://shopify/Product/8641538621597'],
      exactHandles: [
        'kia-sorento-i-2002-2009-led-door-sills-illuminated-scuff-sorento-logo-stainless-steel-entry-guards',
        'kia-sorento-i-2002-2009-custom-illuminated-entry-door-sill-protectors-with-logo-sorento',
      ],
    }),
    Object.freeze({
      key: 'kia-sorento-um', generation: 'UM', years: '',
      label: 'Kia Sorento UM',
      note: 'Catalogue evidence identifies this pair by the UM body code; confirm the vehicle details on the product page before ordering.',
      exactProductIds: ['gid://shopify/Product/8641530986653', 'gid://shopify/Product/8641532133533'],
      exactHandles: [
        'kia-sorento-iii-2015-2020-led-door-sills-illuminated-scuff-sorento-logo-stainless-steel-entry-guards',
        'kia-sorento-iii-2015-2020-custom-illuminated-entry-door-sill-protectors-with-logo-sorento',
      ],
    }),
  ]);
  const MITSUBISHI_OUTLANDER_GENERATION_ROUTES = Object.freeze([
    Object.freeze({
      key: 'mitsubishi-outlander-iv-gn', generation: 'IV / GN', years: '',
      label: 'Mitsubishi Outlander IV / GN',
      note: 'Catalogue titles identify the GN body as 2021–Present; confirm the vehicle details on the product page before ordering.',
      exactProductIds: ['gid://shopify/Product/8642424373405', 'gid://shopify/Product/8641405419677'],
      exactHandles: [
        'mitsubishi-outlander-iv-2021-led-door-sills-illuminated-scuff-outlander-logo-stainless-steel-entry-guards',
        'mitsubishi-outlander-iv-2021-custom-illuminated-entry-door-sill-protectors-with-logo-outlander',
      ],
    }),
  ]);
  const NISSAN_MURANO_GENERATION_ROUTES = Object.freeze([
    Object.freeze({
      key: 'nissan-murano-z51', generation: 'Z51', years: '',
      label: 'Nissan Murano Z51',
      note: 'Confirm the Murano Z51 model and years on the product page before ordering.',
      exactProductIds: ['gid://shopify/Product/8646193283229', 'gid://shopify/Product/9042984435869'],
      exactHandles: [
        'nissan-murano-ii-2008-2014-led-door-sills-illuminated-scuff-murano-logo-stainless-steel-entry-guards',
        'nissan-murano-z51-2008-2014-matte-pro-led-door-sills-murano-logo',
      ],
      exactModelBadgeIds: ['gid://shopify/Product/10325702082779'],
    }),
    Object.freeze({
      key: 'nissan-murano-z52', generation: 'Z52', years: '',
      label: 'Nissan Murano Z52',
      note: 'Confirm the Murano Z52 model and years on the product page before ordering.',
      exactProductIds: ['gid://shopify/Product/8642454454429', 'gid://shopify/Product/9042984468637'],
      exactHandles: [
        'nissan-murano-iii-2014-led-door-sills-illuminated-scuff-murano-logo-stainless-steel-entry-guards',
        'nissan-murano-z52-2014-2025-matte-pro-led-door-sills-murano-logo',
      ],
      exactModelBadgeIds: ['gid://shopify/Product/10325702082779'],
    }),
  ]);
  const PEUGEOT_3008_GENERATION_ROUTES = Object.freeze([
    Object.freeze({
      key: 'peugeot-3008-t84', generation: 'T84 / 3008 I', years: '',
      label: 'Peugeot 3008 T84 / 3008 I',
      note: 'Catalogue pair is for the Peugeot 3008 T84 / 3008 I. Badge artwork is a design match only; verify vehicle mounting on the product page.',
      exactProductIds: ['gid://shopify/Product/8965864784029', 'gid://shopify/Product/9043542442141'],
      exactHandles: [
        'peugeot-3008-i-2009-2016-led-door-sills-illuminated-scuff-3008-logo-stainless-steel-entry-guards',
        'peugeot-3008-t84-2009-2016-matte-pro-led-door-sills-3008-logo',
      ],
      exactModelBadgeIds: ['gid://shopify/Product/10325746286811'],
    }),
    Object.freeze({
      key: 'peugeot-3008-p84', generation: 'P84 / 3008 II', years: '2016–2023',
      label: 'Peugeot 3008 P84 / 3008 II',
      note: 'Catalogue pair is for the Peugeot 3008 P84 / 3008 II (2016–2023). Badge artwork is a design match only; verify vehicle mounting on the product page.',
      exactProductIds: ['gid://shopify/Product/8642456584349', 'gid://shopify/Product/9043537461405'],
      exactHandles: [
        'peugeot-3008-ii-2016-led-door-sills-illuminated-scuff-3008-logo-stainless-steel-entry-guards',
        'peugeot-3008-p84-2016-2023-matte-pro-led-door-sills-3008-logo',
      ],
      exactModelBadgeIds: ['gid://shopify/Product/10325747073243'],
    }),
  ]);
  const SUBARU_FORESTER_GENERATION_ROUTES = Object.freeze([
    Object.freeze({
      key: 'subaru-forester-v-sk', generation: 'V / SK', years: '2018–2024',
      label: 'Subaru Forester V / SK',
      note: 'Exact Subaru Forester V / SK 2018–2024 sill pair. The Forester badge is artwork evidence only; confirm plate dimensions and mounting on the product page.',
      collectionPath: '/collections/subaru-forester-logo-door-sills',
      exactProductIds: ['gid://shopify/Product/8642447704221', 'gid://shopify/Product/9043169050781'],
      exactHandles: [
        'subaru-forester-v-2018-2024-led-door-sills-illuminated-scuff-forester-logo-stainless-steel-entry-guards',
        'subaru-forester-sk-2018-2024-matte-pro-led-door-sills-forester-logo',
      ],
      exactModelBadgeIds: ['gid://shopify/Product/10325891809499'],
    }),
  ]);
  const SUZUKI_GENERATION_ROUTES = Object.freeze([
    Object.freeze({
      key: 'suzuki-vitara-ii', model: 'vitara', generation: 'II', years: '2015–2026',
      label: 'Suzuki Vitara II',
      note: 'Exact Suzuki Vitara pair from the verified root catalogue; Stainless title reads 2015+ while Matte PRO reads 2015–2026. The Vitara badge is an exact model design match; verify mounting on the product page.',
      collectionPath: '/collections/suzuki-illuminated-led-door-sill-tread-plates',
      exactProductIds: ['8641402175645', '9044069777565'], exactHandles: [],
      exactModelBadgeIds: ['gid://shopify/Product/10325894496475'],
    }),
    Object.freeze({
      key: 'suzuki-s-cross-ii', model: 's-cross', generation: 'II', years: '2013–2021',
      label: 'Suzuki S-Cross II',
      note: 'Exact Suzuki S-Cross II pair from the verified root catalogue (2013–2021). The S-Cross badge is an exact model design match; verify mounting on the product page.',
      collectionPath: '/collections/suzuki-illuminated-led-door-sill-tread-plates',
      exactProductIds: ['8956436709533', '9044090585245'], exactHandles: [],
      exactModelBadgeIds: ['gid://shopify/Product/10325894856923'],
    }),
    Object.freeze({
      key: 'suzuki-sx4-ii-jy', model: 'sx4', generation: 'II JY', years: '2013–2021',
      label: 'Suzuki SX4 II JY',
      note: 'Exact Suzuki SX4 II JY pair from the verified root catalogue (2013–2021). The SX4 badge is an exact model design match; verify mounting on the product page.',
      collectionPath: '/collections/suzuki-illuminated-led-door-sill-tread-plates',
      exactProductIds: ['9020930621597', '9044090912925'], exactHandles: [],
      exactModelBadgeIds: ['gid://shopify/Product/10325895282907'],
    }),
  ]);
  const PORSCHE_CAYENNE_GENERATION_ROUTES = Object.freeze([
    Object.freeze({
      key: 'porsche-cayenne-ii', generation: 'II / 92A (2010–2017)', years: '2010–2017',
      label: 'Porsche Cayenne II / 92A',
      note: 'Exact Cayenne II / 92A catalogue route (2010–2017). Badge artwork is a design match only; verify mounting on the product page.',
      collectionPath: '/collections/porsche-cayenne-ii-door-sills',
      exactProductIds: ['8641521549469', '8641522925725', '8641629716637', '8641629749405', '8642457075869', '9043157680285'],
      exactHandles: [
        'porsche-cayenne-ii-2010-2017-custom-illuminated-entry-door-sill-protectors-with-logo-cayenne',
        'porsche-cayenne-ii-2010-2017-custom-illuminated-entry-door-sill-protectors-with-logo-porsche-062000',
        'porsche-cayenne-ii-2010-2017-led-door-sills-illuminated-scuff-porsche-logo-stainless-steel-entry-guards',
        'porsche-cayenne-ii-2010-2017-led-door-sills-illuminated-scuff-turbo-logo-stainless-steel-entry-guards',
        'porsche-cayenne-ii-2010-2017-led-door-sills-illuminated-scuff-cayenne-logo-stainless-steel-entry-guards',
        'porsche-cayenne-92a-2010-2017-matte-pro-led-door-sills-turbo-logo',
      ],
    }),
    Object.freeze({
      key: 'porsche-cayenne-iii', generation: 'III / 9Y0 (2017–Present)', years: '2017–Present',
      label: 'Porsche Cayenne III / 9Y0',
      note: 'Exact Cayenne III / 9Y0 catalogue route (2017–Present). Badge artwork is a design match only; verify mounting on the product page.',
      collectionPath: '/collections/porsche-cayenne-iii-door-sills',
      exactProductIds: ['8641615528093', '8641629782173', '8642436530333', '9042252398749', '9042253447325', '9043128352925'],
      exactHandles: [
        'porsche-cayenne-iii-2017-led-door-sills-illuminated-scuff-cayenne-gts-logo-stainless-steel-entry-guards',
        'porsche-cayenne-iii-2017-led-door-sills-illuminated-scuff-porsche-logo-stainless-steel-entry-guards',
        'porsche-cayenne-iii-2017-led-door-sills-illuminated-scuff-cayenne-logo-stainless-steel-entry-guards-241246',
        'porsche-cayenne-9y0-2017-present-matte-pro-led-door-sills-porsche-logo',
        'porsche-cayenne-9y0-2017-present-matte-pro-led-door-sills-cayenne-logo',
        'porsche-cayenne-9y0-2017-2026-matte-pro-led-door-sills-cayenne-gts-logo',
      ],
    }),
  ]);
  const RENAULT_GENERATION_ROUTES = Object.freeze([
    Object.freeze({ key: 'renault-megane-ii-hatch', model: 'megane', generation: 'II hatch', years: '2002–2009', label: 'Renault Megane II hatch', note: 'Exact pair from the verified Renault catalogue; confirm hatch body style and years on the product page.', collectionPath: '/collections/renault-megane-logo-door-sills', exactProductIds: ['9043168821405', '8641615659165'], exactHandles: ['renault-megane-ii-2002-2009-matte-pro-led-door-sills-megane-logo', 'renault-megane-ii-2002-2009-led-door-sills-illuminated-scuff-megane-logo-stainless-steel-entry-guards'] }),
    Object.freeze({ key: 'renault-megane-iii-hatch', model: 'megane', generation: 'III hatch', years: '2009–2015', label: 'Renault Megane III hatch', note: 'Exact pair from the verified Renault catalogue; confirm hatch body style and years on the product page.', collectionPath: '/collections/renault-megane-logo-door-sills', exactProductIds: ['9042988957853', '8642439086237'], exactHandles: ['renault-megane-iii-2009-2015-matte-pro-led-door-sills-megane-logo', 'renault-megane-iii-2009-2015-led-door-sills-illuminated-scuff-megane-logo-stainless-steel-entry-guards'] }),
    Object.freeze({ key: 'renault-megane-estate-k84', model: 'megane', generation: 'Estate K84', years: '2003–2009', label: 'Renault Megane Estate K84', note: 'Exact pair from the verified Renault catalogue; confirm Estate K84 body style and years on the product page.', collectionPath: '/collections/renault-megane-estate-ii-door-sills', exactProductIds: ['9043550503069', '9030684311709'], exactHandles: ['renault-megane-estate-k84-2003-2009-matte-pro-led-door-sills-megane-logo', 'renault-megane-ii-2002-2009-estate-led-door-sills-illuminated-scuff-megane-logo-stainless-steel-entry-guards'] }),
    Object.freeze({ key: 'renault-megane-estate-kfb', model: 'megane', generation: 'Estate KFB', years: '2016–2024', label: 'Renault Megane Estate KFB', note: 'Exact pair from the verified Renault catalogue; confirm Estate KFB body style and years on the product page.', collectionPath: '/collections/renault-megane-logo-door-sills', exactProductIds: ['9043552534685', '9030684410013'], exactHandles: ['renault-megane-estate-kfb-2016-2024-matte-pro-led-door-sills-megane-logo', 'renault-megane-iv-2015-estate-led-door-sills-illuminated-scuff-megane-logo-stainless-steel-entry-guards'] }),
    Object.freeze({ key: 'renault-clio-iv-x98', model: 'clio', generation: 'IV / X98', years: '2012–2020', label: 'Renault Clio IV / X98', note: 'The verified titles differ by one end year (2012–2019 Matte PRO and 2012–2020 Stainless); confirm the exact year on the product page.', collectionPath: '/collections/renault-door-sills', exactProductIds: ['9043545817245', '8642440790173'], exactHandles: ['renault-clio-iv-x98-2012-2019-matte-pro-led-door-sills-clio-logo', 'renault-clio-iv-20122019-led-door-sills-illuminated-scuff-clio-logo-stainless-steel-entry-guards'] }),
    Object.freeze({ key: 'renault-logan-i', model: 'logan', generation: 'I', years: '2004–2013', label: 'Renault Logan I', note: 'Exact pair from the verified Renault catalogue; confirm the model and years on the product page.', collectionPath: '/collections/renault-logan-logo-door-sills', exactProductIds: ['9043270303901', '8642437546141'], exactHandles: ['renault-logan-i-2004-2013-matte-pro-led-door-sills-logan-logo', 'renault-logan-i-2004-2013-led-door-sills-illuminated-scuff-logan-logo-stainless-steel-entry-guards'] }),
    Object.freeze({ key: 'renault-logan-ii-l8', model: 'logan', generation: 'II / L8', years: '2013–2020', label: 'Renault Logan II / L8', note: 'The verified titles use both 2013–2020 and 2013+; confirm the exact year on the product page.', collectionPath: '/collections/renault-logan-logo-door-sills', exactProductIds: ['9042988236957', '8642438332573'], exactHandles: ['renault-logan-ii-l8-2013-2020-matte-pro-led-door-sills-logan-logo', 'renault-logan-ii-2013-2020-led-door-sills-illuminated-scuff-logan-logo-stainless-steel-entry-guards'] }),
    Object.freeze({ key: 'renault-duster-hs', model: 'duster', generation: 'HS', years: '2010–2017', label: 'Renault Duster HS', note: 'Exact pair from the verified Renault catalogue; confirm the model and years on the product page.', collectionPath: '/collections/renault-duster-logo-door-sills', exactProductIds: ['9042991677597', '8642437283997'], exactHandles: ['renault-duster-hs-2010-2017-matte-pro-led-door-sills-duster-logo', 'renault-duster-i-2010-2018-led-door-sills-illuminated-scuff-duster-logo-stainless-steel-entry-guards'] }),
    Object.freeze({ key: 'renault-duster-p1310', model: 'duster', generation: 'P1310', years: '2024–Present', label: 'Renault Duster P1310', note: 'The verified titles use 2024–2026 and 2024–Present; confirm the exact year on the product page.', collectionPath: '/collections/renault-duster-logo-door-sills', exactProductIds: ['9043157876893', '8652445548701'], exactHandles: ['renault-duster-p1310-2024-2026-matte-pro-led-door-sills-duster-logo', 'renault-duster-iii-2024-led-door-sills-illuminated-scuff-duster-logo-stainless-steel-entry-guards'] }),
    Object.freeze({ key: 'renault-fluence', model: 'fluence', generation: 'Fluence', years: '2009–2017', label: 'Renault Fluence', note: 'Exact pair from the verified Renault catalogue; confirm the model and years on the product page.', collectionPath: '/collections/renault-door-sills', exactProductIds: ['9043270205597', '8642437349533'], exactHandles: ['renault-fluence-2009-2017-matte-pro-led-door-sills-fluence-logo', 'renault-fluence-2009-2017-led-door-sills-illuminated-scuff-fluence-logo-stainless-steel-entry-guards'] }),
    Object.freeze({ key: 'renault-captur-i-j87', model: 'captur', generation: 'I / J87', years: '2013–2019', label: 'Renault Captur I / J87', note: 'Exact pair from the verified Renault catalogue; confirm the model and years on the product page.', collectionPath: '/collections/renault-door-sills', exactProductIds: ['9043270140061', '8642437120157'], exactHandles: ['renault-captur-i-j87-2013-2019-matte-pro-led-door-sills-captur-logo', 'renault-captur-i-2013-2019-led-door-sills-illuminated-scuff-captur-logo-stainless-steel-entry-guards'] }),
    Object.freeze({ key: 'renault-trafic-x82', model: 'trafic', generation: 'X82', years: '2014–Present', label: 'Renault Trafic X82', note: 'The verified titles use 2014–2026 and 2014–Present; confirm the exact year on the product page.', collectionPath: '/collections/renault-door-sills', exactProductIds: ['9043168919709', '8954977550493'], exactHandles: ['renault-trafic-van-x82-2014-2026-matte-pro-led-door-sills-trafic-logo', 'renault-trafic-iii-2014-led-door-sills-illuminated-scuff-trafic-logo-stainless-steel-entry-guards'] }),
    Object.freeze({ key: 'renault-trafic-x83', model: 'trafic', generation: 'X83', years: '2001–2014', label: 'Renault Trafic X83', note: 'Exact pair from the verified Renault catalogue; confirm the model and years on the product page.', collectionPath: '/collections/renault-door-sills', exactProductIds: ['9043158139037', '8641615757469'], exactHandles: ['renault-trafic-van-x83-2001-2014-matte-pro-led-door-sills-trafic-logo', 'renault-trafic-ii-2001-2014-led-door-sills-illuminated-scuff-trafic-logo-stainless-steel-entry-guards'] }),
    Object.freeze({ key: 'renault-laguna-estate-k91', model: 'laguna', generation: 'Estate K91', years: '2007–2015', label: 'Renault Laguna Estate K91', note: 'Exact pair from the verified Renault catalogue; confirm Estate K91 body style and years on the product page.', collectionPath: '/collections/renault-door-sills', exactProductIds: ['9043158073501', '9030684246173'], exactHandles: ['renault-laguna-estate-k91-2007-2015-matte-pro-led-door-sills-laguna-logo', 'renault-laguna-iii-2007-2015-estate-led-door-sills-illuminated-scuff-laguna-logo-stainless-steel-entry-guards'] }),
    Object.freeze({ key: 'renault-laguna-iii', model: 'laguna', generation: 'III', years: '2007–2015', label: 'Renault Laguna III', note: 'Exact pair from the verified Renault catalogue; confirm the model and years on the product page.', collectionPath: '/collections/renault-door-sills', exactProductIds: ['9042748080285', '8641397227677'], exactHandles: ['renault-laguna-iii-2007-2015-matte-pro-led-door-sills-laguna-logo', 'renault-laguna-iii-2007-2015-led-door-sills-illuminated-scuff-laguna-logo-stainless-steel-entry-guards'] }),
    Object.freeze({ key: 'renault-kadjar', model: 'kadjar', generation: 'Kadjar', years: '2015–2022', label: 'Renault Kadjar', note: 'Exact pair from the verified Renault catalogue; confirm the model and years on the product page.', collectionPath: '/collections/renault-door-sills', exactProductIds: ['9043158007965', '8642441019549'], exactHandles: ['renault-kadjar-2015-2022-matte-pro-led-door-sills-kadjar-logo', 'renault-kadjar-2015-2022-led-door-sills-illuminated-scuff-kadjar-logo-stainless-steel-entry-guards'] }),
    Object.freeze({ key: 'renault-espace-jfc', model: 'espace', generation: 'V / JFC', years: '2015–2023', label: 'Renault Espace V / JFC', note: 'Exact pair from the verified Renault catalogue; confirm the model and years on the product page.', collectionPath: '/collections/renault-door-sills', exactProductIds: ['9043157909661', '8961918795933'], exactHandles: ['renault-espace-mpv-jfc-2015-2023-matte-pro-led-door-sills-espace-logo', 'renault-espace-v-2015-2023-led-door-sills-illuminated-scuff-espace-logo-stainless-steel-entry-guards'] }),
    Object.freeze({ key: 'renault-arkana', model: 'arkana', generation: 'Arkana', years: '2019–Present', label: 'Renault Arkana', note: 'The verified titles use 2019–2026 and 2019–Present; confirm the exact year on the product page.', collectionPath: '/collections/renault-door-sills', exactProductIds: ['9043157844125', '8642440528029'], exactHandles: ['renault-arkana-2019-2026-matte-pro-led-door-sills-arkana-logo', 'renault-arkana-2019-led-door-sills-illuminated-scuff-arkana-logo-stainless-steel-entry-guards'] }),
    Object.freeze({ key: 'renault-scenic-jz', model: 'scenic', generation: 'III / JZ', years: '2009–2016', label: 'Renault Scenic III / JZ', note: 'Exact pair from the verified Renault catalogue; confirm the model and years on the product page.', collectionPath: '/collections/renault-scenic-logo-door-sills', exactProductIds: ['8641405386909', '8642441609373'], exactHandles: ['renault-scenic-iii-2009-2016-custom-illuminated-entry-door-sill-protectors-with-logo-scenic', 'renault-scenic-iii-2009-2016-led-door-sills-illuminated-scuff-scenic-logo-stainless-steel-entry-guards'] }),
  ]);
  const FINAL_FOUR_ROUTES = Object.freeze([
    Object.freeze({
      key: 'haval-h6-iii-b06', brand: 'haval', model: 'H6', generation: 'III B06', years: '2020–2026',
      label: 'Haval H6 III B06 (2020–2026)',
      collectionPath: '/collections/haval-led-door-sills', queryParam: 'lds_haval_model',
      exactProductIds: ['8953961742493', '9044876853405'], exactHandles: [
        'haval-h6-iii-2020-led-door-sills-illuminated-scuff-haval-logo-stainless-steel-entry-guards',
        'haval-h6-iii-b06-2020-2026-matte-pro-led-door-sills-haval-logo',
      ], exactModelBadgeIds: [],
      note: 'Exact Haval H6 III B06 sill pair. Haval badge cards are brand artwork only and do not establish H6 mounting compatibility.',
    }),
    Object.freeze({
      key: 'jetour-x70', brand: 'jetour', model: 'X70', generation: '', years: '2018–2026',
      label: 'Jetour X70 (2018–2026)',
      collectionPath: '/collections/jetour-led-door-sills', queryParam: 'lds_jetour_model',
      exactProductIds: ['8951745249437', '9044110573725'], exactHandles: [
        'jetour-x70-2018-led-door-sills-illuminated-scuff-jetour-logo-stainless-steel-entry-guards',
        'jetour-x70-2018-2026-matte-pro-led-door-sills-jetour-logo',
      ], exactModelBadgeIds: [],
      note: 'Exact Jetour X70 Stainless Steel and Matte PRO pair. Badge category is hidden until an exact Jetour badge source exists.',
    }),
    Object.freeze({
      key: 'ssangyong-rexton-y400', brand: 'ssangyong', model: 'Rexton', generation: 'Y400', years: '2017–2023',
      label: 'SsangYong Rexton Y400 (2017–2023)',
      collectionPath: '/collections/ssangyong-door-sills', queryParam: 'lds_ssangyong_model',
      exactProductIds: ['8931611246749', '9044090486941'], exactHandles: [
        'ssangyong-rexton-iii-2017-led-door-sills-illuminated-scuff-rexton-logo-stainless-steel-entry-guards',
        'ssangyong-rexton-y400-2017-2023-matte-pro-led-door-sills-rexton-logo',
      ], exactModelBadgeIds: ['10325889876187'],
      note: 'Exact Rexton Y400 Stainless Steel / Matte PRO route. REXTON is a matching design; the badge card must not claim sill or mounting fitment.',
    }),
    Object.freeze({
      key: 'vauxhall-crossland-x', brand: 'vauxhall', model: 'Crossland X', generation: '', years: '2017–Present',
      label: 'Vauxhall Crossland X (2017–Present)',
      collectionPath: '/collections/vauxhall-crossland-x-logo-door-sills', queryParam: 'lds_vauxhall_model',
      exactProductIds: ['8642432073885', '9044301152413'], exactHandles: [
        'vauxhall-crossland-x-2017-led-door-sills-illuminated-scuff-crossland-x-logo-stainless-steel-entry-guards',
        'vauxhall-crossland-x-2017-2026-matte-pro-led-door-sills-crossland-x-logo',
      ], exactModelBadgeIds: [],
      note: 'Exact Crossland X Stainless Steel and Matte PRO route. Vauxhall Insignia is brand-level artwork for the unfiltered hub only, never Crossland X compatibility.',
    }),
    Object.freeze({
      key: 'bmw-4-series-coupe-f32', brand: 'bmw', model: '4 Series Coupe', generation: 'F32', years: '2013–2020',
      label: 'BMW 4 Series Coupe F32 (2013–2020)',
      collectionPath: '/collections/bmw-door-sills', queryParam: 'lds_verified_model',
      exactProductIds: ['9036267290781', '9036267159709', '9036267126941'], exactHandles: [], exactModelBadgeIds: [],
      note: 'Exact BMW 4 Series Coupe F32 Matte PRO products (2013–2020). No exact model badge mapping is asserted; brand artwork remains separate and does not establish fitment.',
    }),
    Object.freeze({
      key: 'bmw-3-series-coupe-e92', brand: 'bmw', model: '3 Series Coupe', generation: 'E92', years: '2006–2013',
      label: 'BMW 3 Series Coupe E92 (2006–2013)',
      collectionPath: '/collections/bmw-door-sills', queryParam: 'lds_verified_model',
      exactProductIds: ['9036268109981', '9036267880605'], exactHandles: [], exactModelBadgeIds: [],
      note: 'Exact BMW 3 Series Coupe E92 Stainless Steel products (2006–2013). No exact model badge mapping is asserted; brand artwork remains separate and does not establish fitment.',
    }),
    Object.freeze({
      key: 'bmw-4-series-coupe-g22', brand: 'bmw', model: '4 Series Coupe', generation: 'G22', years: '2020–Present',
      label: 'BMW 4 Series Coupe G22 (2020–Present)',
      collectionPath: '/collections/bmw-door-sills', queryParam: 'lds_verified_model',
      exactProductIds: ['9036267356317', '9036267389085', '9036267487389'], exactHandles: [], exactModelBadgeIds: [],
      note: 'Exact BMW 4 Series Coupe G22 Stainless Steel products (2020–Present). The conflicting G20-body Matte PRO records are excluded; brand artwork remains separate and does not establish fitment.',
    }),
    Object.freeze({
      key: 'land-rover-freelander-2', brand: 'land rover', model: 'Freelander 2', generation: '', years: '2006–2014',
      label: 'Land Rover Freelander 2 (2006–2014)',
      collectionPath: '/collections/land-rover-door-sills', queryParam: 'lds_verified_model',
      exactProductIds: ['9037028720797', '9037892812957'], exactHandles: [], exactModelBadgeIds: [],
      note: 'Exact Land Rover Freelander 2 Stainless Steel products (2006–2014). Brand artwork remains separate and does not establish fitment.',
    }),
    Object.freeze({
      key: 'mazda-6-wagon-gj-gl', brand: 'mazda', model: '6 Wagon', generation: 'GJ/GL', years: '2012–2024',
      label: 'Mazda 6 Wagon GJ/GL (2012–2024)',
      collectionPath: '/collections/mazda-door-sills', queryParam: 'lds_verified_model',
      exactProductIds: ['9030687391901', '9030684901533'], exactHandles: [], exactModelBadgeIds: [],
      note: 'Exact Mazda 6 Wagon GJ/GL Stainless Steel products (2012–2024). Brand artwork remains separate and does not establish fitment.',
    }),
    Object.freeze({
      key: 'mazda-6-wagon-gz', brand: 'mazda', model: '6 Wagon', generation: 'GZ', years: '2008–2012',
      label: 'Mazda 6 Wagon GZ (2008–2012)',
      collectionPath: '/collections/mazda-door-sills', queryParam: 'lds_verified_model',
      exactProductIds: ['9030684868765'], exactHandles: [], exactModelBadgeIds: [],
      note: 'Exact Mazda 6 Wagon GZ Stainless Steel product (2008–2012). Brand artwork remains separate and does not establish fitment.',
    }),
  ]);
  const isRenaultGeneralBadge = (product, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'renault') return false;
    return normalizeRouteProductId(product?.id) === '10325817327835'
      || String(product?.handle || '').trim() === 'renault-diamond-emblem-led-license-plate-badge';
  };
  const materialCache = new WeakMap();
  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };
  const hubBrand = hub => hub?.dataset.ldsHubBrand?.trim() || 'Vehicle';
  const HUB_SELECTION_STORAGE_PREFIX = 'lds-hub-vehicle-selection:v1';
  const selectionText = value => String(value || '').trim().toLowerCase();
  const selectionPath = value => {
    try {
      const url = new URL(value || location.pathname, location.origin);
      return url.pathname.replace(/\/$/, '') || '/';
    } catch (_error) {
      return String(value || '').trim().replace(/\/$/, '') || '/';
    }
  };
  const selectionDestination = value => {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin) return '';
      return url.pathname + url.search;
    } catch (_error) {
      return String(value || '').trim();
    }
  };
  const selectionTheme = () => {
    try {
      const previewThemeId = new URLSearchParams(location.search).get('preview_theme_id');
      return String(previewThemeId || window.Shopify?.theme?.id || 'live').trim();
    } catch (_error) {
      return 'live';
    }
  };
  const hubSelectionContext = (hub, picker, brand) => ({
    theme: selectionTheme(),
    brand: selectionText(brand),
    path: selectionPath(picker?.brand?.value || hub?.dataset?.ldsHubPath || location.pathname),
  });
  const hubSelectionStorageKey = context => [
    HUB_SELECTION_STORAGE_PREFIX,
    context.theme,
    context.brand,
    context.path,
  ].map(value => encodeURIComponent(String(value || ''))).join(':');
  const readHubSelection = key => {
    try {
      const raw = window.sessionStorage?.getItem(key);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (_error) {
      return null;
    }
  };
  const writeHubSelection = (key, value) => {
    try { window.sessionStorage?.setItem(key, JSON.stringify(value)); } catch (_error) { /* unavailable */ }
  };
  const clearHubSelection = key => {
    try { window.sessionStorage?.removeItem(key); } catch (_error) { /* unavailable */ }
  };
  const selectionGenerationText = value => selectionText(value)
    .replace(/\s+\(\d{4}\s*(?:[–—-]|through)\s*(?:\d{4}|present)\)$/i, '')
    .replace(/\s+\(\d{4}\+\)$/i, '');
  const selectionGenerationMatches = (variant, saved) => {
    if (!variant || !saved) return false;
    const savedValue = String(saved.generationValue || '').trim();
    if (savedValue) return selectionDestination(variant.url) === selectionDestination(savedValue);
    return selectionGenerationText(variant.generation) === selectionGenerationText(saved.generation);
  };
  const localUrl = value => {
    const url = new URL(value, location.origin);
    if (url.origin !== location.origin) throw new Error('Invalid catalogue URL');
    return url;
  };
  const cleanLink = value => {
    const url = localUrl(value);
    return url.pathname + url.search;
  };
  const finishUrl = (collection, tag) => {
    const url = localUrl(collection);
    const segments = url.pathname.replace(/\/$/, '').split('/');
    // Shopify combines collection tag filters with '+', not another path segment.
    if (segments.length === 4 && segments[1] === 'collections') {
      const tags = segments[3].split('+');
      if (!tags.includes(tag)) tags.push(tag);
      segments[3] = tags.join('+');
      url.pathname = segments.join('/');
    } else {
      url.pathname = url.pathname.replace(/\/$/, '') + '/' + tag;
    }
    url.search = '';
    return url.href;
  };
  // These model routes are exact, complete picker results. Their material
  // tag URLs are not route-aware on the public server, so selected results
  // must not emit a brand-wide "View all" link when every item is already in
  // the hub. Keep this allowlist narrow; generic/default links keep the old
  // behavior below.
  const EXACT_ROUTE_KEYS = new Map([
    ['/collections/suzuki-illuminated-led-door-sill-tread-plates', {param: 'lds_suzuki_model', keys: new Set(['suzuki-vitara-ii', 'suzuki-s-cross-ii', 'suzuki-sx4-ii-jy'])}],
    ['/collections/volvo-s90-logo-door-sills', {param: 'lds_volvo_model', keys: new Set(['volvo-s90-ii'])}],
    ['/collections/tesla-door-sills', {param: 'lds_tesla_model', keys: new Set(['tesla-model-s-2012'])}],
    ['/collections/zeekr-door-sills', {param: 'lds_zeekr_model', keys: new Set(['zeekr-001-2021'])}],
    ['/collections/haval-led-door-sills', {param: 'lds_haval_model', keys: new Set(['haval-h6-iii-b06'])}],
    ['/collections/jetour-led-door-sills', {param: 'lds_jetour_model', keys: new Set(['jetour-x70'])}],
    ['/collections/ssangyong-door-sills', {param: 'lds_ssangyong_model', keys: new Set(['ssangyong-rexton-y400'])}],
    ['/collections/vauxhall-crossland-x-logo-door-sills', {param: 'lds_vauxhall_model', keys: new Set(['vauxhall-crossland-x'])}],
    ['/collections/bmw-door-sills', {param: 'lds_verified_model', keys: new Set(['bmw-4-series-coupe-f32', 'bmw-3-series-coupe-e92', 'bmw-4-series-coupe-g22'])}],
    ['/collections/land-rover-door-sills', {param: 'lds_verified_model', keys: new Set(['land-rover-freelander-2'])}],
    ['/collections/mazda-door-sills', {param: 'lds_verified_model', keys: new Set(['mazda-6-wagon-gj-gl', 'mazda-6-wagon-gz'])}],
  ]);
  const isExactPickerRoute = value => {
    const url = localUrl(value);
    const route = EXACT_ROUTE_KEYS.get(url.pathname);
    return Boolean(route && route.keys.has(url.searchParams.get(route.param)));
  };
  const renderedMaterial = product => {
    if (!product || typeof product !== 'object') return '';
    if (materialCache.has(product)) return materialCache.get(product);
    let value = '';
    if (typeof product.html === 'string' && product.html) {
      const doc = new DOMParser().parseFromString(product.html, 'text/html');
      value = doc.querySelector('.lds-search-product__material')?.textContent?.trim() || '';
    }
    materialCache.set(product, value);
    return value;
  };
  // These eight exact RAM DT source products are verified Stainless Steel.
  // Keep the exception route- and ID-scoped; generic card text remains authoritative elsewhere.
  const RAM_DT_STAINLESS_PRODUCT_IDS = new Set([
    '8940641353885', '8910615150749', '8906942775453', '8858013204637',
    '8642554200221', '8642369159325', '8642368340125', '8641630929053',
  ]);
  const normalizeRamDtProductId = value => String(value || '')
    .replace(/^gid:\/\/shopify\/Product\//i, '');
  const isRamDtStainlessProduct = (product, context) => {
    if (String(context?.brand || '').trim().toLowerCase() !== 'ram') return false;
    let path = '';
    try { path = localUrl(context?.collectionUrl || '').pathname.replace(/\/$/, '').toLowerCase(); }
    catch (_error) { return false; }
    return path === '/collections/ram-1500-v-door-sills'
      && RAM_DT_STAINLESS_PRODUCT_IDS.has(normalizeRamDtProductId(product?.id));
  };
  const finishOf = (product, context) => {
    if (isRamDtStainlessProduct(product, context)) return 'stainless';
    const material = renderedMaterial(product).replace(/\s+/g, ' ').trim().toLowerCase();
    if (material === 'stainless steel') return 'stainless';
    if (material === 'matte pro') return 'matte';
    return 'unknown';
  };
  const normalizePeugeot3008ProductId = value => String(value || '')
    .replace(/^gid:\/\/shopify\/Product\//i, '');
  const peugeot3008ProductMatches = (product, route) => {
    if (!product || !route) return false;
    const id = normalizePeugeot3008ProductId(product.id);
    const idMatch = route.exactProductIds.some(expected =>
      normalizePeugeot3008ProductId(expected) === id);
    const handleMatch = route.exactHandles.includes(String(product.handle || '').trim());
    return idMatch || handleMatch;
  };
  const selectedPeugeot3008Route = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'peugeot') return null;
    const model = picker.model?.selectedOptions?.[0]?.textContent?.trim().toLowerCase();
    if (model !== '3008') return null;
    const key = picker.generation?.selectedOptions?.[0]?.dataset?.ldsPeugeot3008Route || '';
    return PEUGEOT_3008_GENERATION_ROUTES.find(route => route.key === key) || null;
  };
  const selectedPeugeot3008Model = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'peugeot') return false;
    return picker.model?.selectedOptions?.[0]?.textContent?.trim().toLowerCase() === '3008';
  };
  const scopePeugeot3008Products = (products, route) => {
    const source = Array.isArray(products) ? products : [];
    const allowedRoutes = route ? [route] : PEUGEOT_3008_GENERATION_ROUTES;
    const sills = source.filter(product => !product.isBadge && product.kind !== 'badge');
    const matched = sills.filter(product => allowedRoutes.some(item => peugeot3008ProductMatches(product, item)));
    const expectedCount = allowedRoutes.reduce((count, item) => count + item.exactProductIds.length, 0);
    if (matched.length !== expectedCount) {
      throw new Error(`Exact ${route?.label || 'Peugeot 3008'} products could not be verified`);
    }
    return matched;
  };
  const addPeugeot3008GenerationRoutes = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'peugeot') return;
    const group = (picker.groups || []).find(item =>
      String(item.label || '').trim().toLowerCase() === '3008');
    if (!group?.parent) return;
    let selectedRouteKey = '';
    const routeVariants = PEUGEOT_3008_GENERATION_ROUTES.map(route => ({
      generation: route.generation, years: route.years,
      url: `${group.parent}?lds_generation=${encodeURIComponent(route.key)}`,
    }));
    group.variants = routeVariants;
    picker.generation.addEventListener('change', () => {
      selectedRouteKey = picker.generation.selectedOptions?.[0]?.dataset?.ldsPeugeot3008Route || '';
    });
    const originalChooseModel = picker.chooseModel.bind(picker);
    picker.chooseModel = (...args) => {
      const previousRouteKey = selectedRouteKey
        || picker.generation?.selectedOptions?.[0]?.dataset?.ldsPeugeot3008Route || '';
      const result = originalChooseModel(...args);
      const model = picker.model?.selectedOptions?.[0]?.textContent?.trim().toLowerCase();
      if (model !== '3008') {
        selectedRouteKey = '';
        return result;
      }
      if (!picker.generation) return result;
      const options = [...picker.generation.options]
        .filter(option => option.value.startsWith(`${group.parent}?lds_generation=`));
      let restoredOption = null;
      PEUGEOT_3008_GENERATION_ROUTES.forEach((route, index) => {
        const option = options[index];
        if (!option) return;
        option.textContent = route.generation + (route.years ? ` (${route.years})` : '');
        option.dataset.ldsPeugeot3008Route = route.key;
        option.title = route.note;
        if (route.key === previousRouteKey) restoredOption = option;
      });
      if (restoredOption) {
        selectedRouteKey = previousRouteKey;
        picker.generation.value = restoredOption.value;
        picker.destination(restoredOption.value);
      }
      return result;
    };
  };
  const normalizeSubaruForesterProductId = value => String(value || '')
    .replace(/^gid:\/\/shopify\/Product\//i, '');
  const subaruForesterProductMatches = (product, route) => {
    if (!product || !route) return false;
    const id = normalizeSubaruForesterProductId(product.id);
    const idMatch = route.exactProductIds.some(expected =>
      normalizeSubaruForesterProductId(expected) === id);
    const handleMatch = route.exactHandles.includes(String(product.handle || '').trim());
    return idMatch || handleMatch;
  };
  const selectedSubaruForesterRoute = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'subaru') return null;
    if (picker.model?.selectedOptions?.[0]?.textContent?.trim().toLowerCase() !== 'forester') return null;
    const key = picker.generation?.selectedOptions?.[0]?.dataset?.ldsSubaruForesterRoute || '';
    return SUBARU_FORESTER_GENERATION_ROUTES.find(route => route.key === key) || null;
  };
  const selectedSubaruForesterModel = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'subaru') return false;
    return picker.model?.selectedOptions?.[0]?.textContent?.trim().toLowerCase() === 'forester';
  };
  const scopeSubaruForesterProducts = (products, route) => {
    const source = Array.isArray(products) ? products : [];
    const selected = route ? [route] : SUBARU_FORESTER_GENERATION_ROUTES;
    const sills = source.filter(product => !product.isBadge && product.kind !== 'badge');
    const matched = sills.filter(product => selected.some(item => subaruForesterProductMatches(product, item)));
    const expectedCount = selected.reduce((count, item) => count + item.exactProductIds.length, 0);
    if (matched.length !== expectedCount) {
      throw new Error('Exact ' + (route?.label || 'Subaru Forester') + ' products could not be verified');
    }
    // The public Forester logo collection is mixed SH/SJ/SK. Keep only the
    // selected SK/V sill pair; exact model badge cards are added below.
    return matched;
  };
  const addSubaruForesterGenerationRoutes = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'subaru') return;
    const groups = Array.isArray(picker.groups) ? picker.groups : [];
    let group = groups.find(item => ['forester', 'forester logo'].includes(
      String(item.label || '').trim().toLowerCase()));
    if (!group) {
      group = {label: 'Forester', parent: SUBARU_FORESTER_GENERATION_ROUTES[0].collectionPath, variants: []};
      picker.groups = [...groups, group];
      picker.model.add(new Option('Forester', String(picker.groups.length - 1)));
    } else {
      // The source row is titled Forester Logo; keep the user-facing model
      // label aligned with the exact Forester V/SK route.
      group.label = 'Forester';
      group.parent = SUBARU_FORESTER_GENERATION_ROUTES[0].collectionPath;
    }
    // picker.load() already copied each parsed group label into the native
    // model <select>. Keep that option synchronized when an existing mixed
    // source row is relabeled, otherwise selectedSubaruForesterModel() still
    // sees the stale "Forester Logo" text and the route remains unselected.
    const groupIndex = picker.groups.indexOf(group);
    const modelOption = [...(picker.model?.options || [])].find(option => option.value === String(groupIndex));
    if (modelOption) modelOption.textContent = group.label;
    let selectedRouteKey = '';
    const routeVariants = SUBARU_FORESTER_GENERATION_ROUTES.map(route => ({
      generation: route.generation, years: route.years,
      url: group.parent + (group.parent.includes('?') ? '&' : '?') + 'lds_generation=' + encodeURIComponent(route.key),
    }));
    group.variants = routeVariants;
    picker.generation.addEventListener('change', () => {
      selectedRouteKey = picker.generation.selectedOptions?.[0]?.dataset?.ldsSubaruForesterRoute || '';
    });
    const originalChooseModel = picker.chooseModel.bind(picker);
    picker.chooseModel = (...args) => {
      const previousRouteKey = selectedRouteKey
        || picker.generation?.selectedOptions?.[0]?.dataset?.ldsSubaruForesterRoute || '';
      const result = originalChooseModel(...args);
      const model = picker.model?.selectedOptions?.[0]?.textContent?.trim().toLowerCase();
      if (model !== 'forester') {
        selectedRouteKey = '';
        return result;
      }
      if (!picker.generation) return result;
      // Do not expose the mixed-collection parent as an "All generations"
      // destination. This route is deliberately exact V/SK only.
      [...picker.generation.options]
        .filter(option => option.value === group.parent)
        .forEach(option => option.remove());
      const options = [...picker.generation.options]
        .filter(option => option.value.startsWith(group.parent + '?lds_generation='));
      let restoredOption = null;
      SUBARU_FORESTER_GENERATION_ROUTES.forEach((route, index) => {
        const option = options[index];
        if (!option) return;
        option.textContent = route.generation + (route.years ? ' (' + route.years + ')' : '');
        option.dataset.ldsSubaruForesterRoute = route.key;
        option.title = route.note;
        if (route.key === previousRouteKey) restoredOption = option;
      });
      const targetOption = restoredOption || options[0];
      if (targetOption) {
        selectedRouteKey = targetOption.dataset.ldsSubaruForesterRoute;
        picker.generation.value = targetOption.value;
        picker.destination(targetOption.value);
      }
      return result;
    };
  };
  const normalizeRouteProductId = value => String(value || '').replace('gid://shopify/Product/', '');
  const routeProductMatches = (product, route) => {
    if (!product || !route) return false;
    return route.exactProductIds.some(expected => normalizeRouteProductId(expected) === normalizeRouteProductId(product.id))
      || route.exactHandles.includes(String(product.handle || '').trim());
  };
  const selectedPorscheCayenneRoute = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'porsche') return null;
    if (picker.model?.selectedOptions?.[0]?.textContent?.trim().toLowerCase() !== 'cayenne') return null;
    const key = picker.generation?.selectedOptions?.[0]?.dataset?.ldsPorscheCayenneRoute || '';
    return PORSCHE_CAYENNE_GENERATION_ROUTES.find(route => route.key === key) || null;
  };
  const scopePorscheCayenneProducts = (products, route) => {
    const source = Array.isArray(products) ? products : [];
    const matched = source.filter(product => !product.isBadge && product.kind !== 'badge')
      .filter(product => routeProductMatches(product, route));
    if (matched.length !== route.exactProductIds.length) {
      throw new Error('Exact ' + route.label + ' products could not be verified');
    }
    return source.filter(product => product.isBadge || product.kind === 'badge' || routeProductMatches(product, route));
  };
  const addPorscheCayenneGenerationRoutes = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'porsche') return;
    const group = (picker.groups || []).find(item => String(item.label || '').trim().toLowerCase() === 'cayenne');
    if (!group?.parent) return;
    let selectedRouteKey = '';
    group.variants = PORSCHE_CAYENNE_GENERATION_ROUTES.map(route => ({
      generation: route.generation, years: '', url: route.collectionPath,
    }));
    picker.generation.addEventListener('change', () => {
      selectedRouteKey = picker.generation.selectedOptions?.[0]?.dataset?.ldsPorscheCayenneRoute || '';
    });
    const originalChooseModel = picker.chooseModel.bind(picker);
    picker.chooseModel = (...args) => {
      const previousRouteKey = selectedRouteKey
        || picker.generation?.selectedOptions?.[0]?.dataset?.ldsPorscheCayenneRoute || '';
      const result = originalChooseModel(...args);
      if (picker.model?.selectedOptions?.[0]?.textContent?.trim().toLowerCase() !== 'cayenne') {
        selectedRouteKey = '';
        return result;
      }
      const options = [...picker.generation.options];
      let restoredOption = null;
      PORSCHE_CAYENNE_GENERATION_ROUTES.forEach(route => {
        const option = options.find(candidate => new URL(candidate.value, location.origin).pathname === route.collectionPath);
        if (!option) return;
        option.textContent = route.generation;
        option.dataset.ldsPorscheCayenneRoute = route.key;
        option.title = route.note;
        if (route.key === previousRouteKey) restoredOption = option;
      });
      if (restoredOption) {
        selectedRouteKey = previousRouteKey;
        picker.generation.value = restoredOption.value;
        picker.destination(restoredOption.value);
      }
      return result;
    };
  };
  const RENAULT_MODEL_LABELS = Object.freeze({
    megane: 'Megane', clio: 'Clio', logan: 'Logan', duster: 'Duster',
    fluence: 'Fluence', captur: 'Captur', trafic: 'Trafic', laguna: 'Laguna',
    kadjar: 'Kadjar', espace: 'Espace', arkana: 'Arkana', scenic: 'Scenic',
  });
  const SUZUKI_MODEL_LABELS = Object.freeze({
    vitara: 'Vitara', 's-cross': 'S-Cross', sx4: 'SX4',
  });
  const selectedSuzukiRoute = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'suzuki') return null;
    const option = picker.generation?.selectedOptions?.[0];
    const key = option?.dataset?.ldsSuzukiRoute || '';
    if (key) return SUZUKI_GENERATION_ROUTES.find(route => route.key === key) || null;
    const value = option?.value || picker.target || '';
    try {
      const queryKey = new URL(value, location.origin).searchParams.get('lds_suzuki_model') || '';
      return SUZUKI_GENERATION_ROUTES.find(route => route.key === queryKey) || null;
    } catch (_error) {
      return null;
    }
  };
  const selectedFinalFourRoute = (picker, brand) => {
    const brandKey = String(brand || '').normalize('NFKC').toLowerCase().replace(/[^a-z0-9]+/g, '');
    const candidates = [
      picker?.target,
      picker?.generation?.value,
    ].filter(Boolean);
    for (const value of candidates) {
      try {
        const url = new URL(value, location.origin);
        const route = FINAL_FOUR_ROUTES.find(item => item.brand.normalize('NFKC').toLowerCase().replace(/[^a-z0-9]+/g, '') === brandKey
          && item.collectionPath === url.pathname
          && url.searchParams.get(item.queryParam) === item.key);
        if (route) return route;
      } catch (_error) {
        // A stale picker value is ignored; the next candidate may be current.
      }
    }
    return null;
  };
  const scopeFinalFourProducts = (products, route) => {
    const source = Array.isArray(products) ? products : [];
    const expected = new Set(route?.exactProductIds || []);
    const matched = source
      .filter(product => !product.isBadge && product.kind !== 'badge')
      .filter(product => routeProductMatches(product, route));
    const matchedIds = new Set(matched.map(product => normalizeRouteProductId(product.id)));
    if (!route || matched.length !== expected.size || [...expected].some(id => !matchedIds.has(normalizeRouteProductId(id)))) {
      throw new Error(`Exact ${route?.label || 'final-four'} catalogue products could not be verified`);
    }
    return matched;
  };
  const scopeSuzukiProducts = (products, route) => {
    const source = Array.isArray(products) ? products : [];
    const expectedIds = new Set((route?.exactProductIds || []).map(normalizeRouteProductId));
    const matched = source
      .filter(product => !product.isBadge && product.kind !== 'badge')
      .filter(product => routeProductMatches(product, route));
    const matchedIds = new Set(matched.map(product => normalizeRouteProductId(product.id)));
    if (!route || matched.length !== expectedIds.size || [...expectedIds].some(id => !matchedIds.has(id))) {
      throw new Error('Exact Suzuki catalogue products could not be verified');
    }
    return matched;
  };
  const addSuzukiGenerationRoutes = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'suzuki' || picker.dataset.ldsSuzukiRoutes) return;
    picker.dataset.ldsSuzukiRoutes = 'true';
    const groups = picker.groups || (picker.groups = []);
    const modelKeys = [...new Set(SUZUKI_GENERATION_ROUTES.map(route => route.model))];
    modelKeys.forEach(model => {
      const routes = SUZUKI_GENERATION_ROUTES.filter(route => route.model === model);
      const label = SUZUKI_MODEL_LABELS[model] || model;
      let group = groups.find(item => String(item.label || '').trim().toLowerCase() === label.toLowerCase());
      if (!group) {
        group = {label, parent: routes[0].collectionPath, variants: []};
        groups.push(group);
        picker.model.add(new Option(group.label, String(groups.length - 1)));
      }
      group.label = label;
      group.ldsSuzukiModel = model;
      group.parent = routes[0].collectionPath;
      group.variants = routes.map(route => ({
        generation: route.generation,
        years: route.years,
        url: route.collectionPath + '?lds_suzuki_model=' + encodeURIComponent(route.key),
      }));
    });
    let selectedRouteKey = '';
    picker.generation.addEventListener('change', () => {
      const option = picker.generation.selectedOptions?.[0];
      selectedRouteKey = option?.dataset?.ldsSuzukiRoute || '';
      if (!selectedRouteKey) {
        try {
          selectedRouteKey = new URL(option?.value || '', location.origin).searchParams.get('lds_suzuki_model') || '';
        } catch (_error) {
          selectedRouteKey = '';
        }
      }
    });
    const originalChooseModel = picker.chooseModel.bind(picker);
    picker.chooseModel = (...args) => {
      const previousRouteKey = selectedRouteKey
        || picker.generation?.selectedOptions?.[0]?.dataset?.ldsSuzukiRoute || '';
      const result = originalChooseModel(...args);
      const group = picker.model.value === '' ? null : groups[Number(picker.model.value)];
      const model = group?.ldsSuzukiModel;
      const routes = model ? SUZUKI_GENERATION_ROUTES.filter(route => route.model === model) : [];
      if (!routes.length) {
        selectedRouteKey = '';
        return result;
      }
      [...picker.generation.options]
        .filter(option => option.value === group.parent)
        .forEach(option => option.remove());
      const options = [...picker.generation.options].filter(option => option.value.startsWith(group.parent + '?lds_suzuki_model='));
      let restoredOption = null;
      routes.forEach((route, index) => {
        const option = options[index];
        if (!option) return;
        option.textContent = route.generation + (route.years ? ' (' + route.years + ')' : '');
        option.dataset.ldsSuzukiRoute = route.key;
        option.title = route.note;
        if (route.key === previousRouteKey) restoredOption = option;
      });
      const targetOption = restoredOption || options[0];
      if (targetOption) {
        selectedRouteKey = targetOption.dataset.ldsSuzukiRoute;
        picker.generation.value = targetOption.value;
        picker.destination(targetOption.value);
      }
      return result;
    };
  };
  const selectedRenaultRoute = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'renault') return null;
    const key = picker.generation?.selectedOptions?.[0]?.dataset?.ldsRenaultRoute || '';
    return RENAULT_GENERATION_ROUTES.find(route => route.key === key) || null;
  };
  const selectedRenaultModelKey = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'renault') return '';
    const group = picker.groups?.[Number(picker.model?.value)];
    if (group?.ldsRenaultModel) return group.ldsRenaultModel;
    const label = picker.model?.selectedOptions?.[0]?.textContent?.trim().toLowerCase() || '';
    return Object.keys(RENAULT_MODEL_LABELS).find(key => label === key) || '';
  };
  const selectedRenaultRoutes = (picker, brand) => {
    const selected = selectedRenaultRoute(picker, brand);
    if (selected) return [selected];
    const model = selectedRenaultModelKey(picker, brand);
    return model ? RENAULT_GENERATION_ROUTES.filter(route => route.model === model) : null;
  };
  const scopeRenaultProducts = (products, routes) => {
    const source = Array.isArray(products) ? products : [];
    const routeList = (Array.isArray(routes) ? routes : [routes]).filter(Boolean);
    const expectedIds = new Set(routeList.flatMap(route => route.exactProductIds)
      .map(normalizeRouteProductId));
    const matched = source.filter(product => !product.isBadge && product.kind !== 'badge')
      .filter(product => routeList.some(route => routeProductMatches(product, route)));
    const matchedIds = new Set(matched.map(product => normalizeRouteProductId(product.id)));
    if (matched.length !== expectedIds.size || [...expectedIds].some(id => !matchedIds.has(id))) {
      throw new Error('Exact Renault catalogue products could not be verified');
    }
    return source.filter(product => product.isBadge || product.kind === 'badge'
      || routeList.some(route => routeProductMatches(product, route)));
  };
  const addRenaultGenerationRoutes = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'renault' || picker.dataset.ldsRenaultRoutes) return;
    picker.dataset.ldsRenaultRoutes = 'true';
    const groups = picker.groups || (picker.groups = []);
    const modelKeys = [...new Set(RENAULT_GENERATION_ROUTES.map(route => route.model))];
    modelKeys.forEach(model => {
      const routes = RENAULT_GENERATION_ROUTES.filter(route => route.model === model);
      let group = groups.find(item => String(item.label || '').trim().toLowerCase() === model);
      if (!group) {
        group = {label: RENAULT_MODEL_LABELS[model], parent: routes[0].collectionPath, variants: []};
        groups.push(group);
        picker.model.add(new Option(group.label, String(groups.length - 1)));
      }
      group.ldsRenaultModel = model;
      group.parent = group.parent || routes[0].collectionPath;
      group.variants = routes.map(route => ({
        generation: route.generation,
        years: route.years,
        url: route.collectionPath + '?lds_generation=' + encodeURIComponent(route.key),
      }));
    });
    let selectedRouteKey = '';
    picker.generation.addEventListener('change', () => {
      selectedRouteKey = picker.generation.selectedOptions?.[0]?.dataset?.ldsRenaultRoute || '';
    });
    const originalChooseModel = picker.chooseModel.bind(picker);
    picker.chooseModel = (...args) => {
      const previousRouteKey = selectedRouteKey;
      const result = originalChooseModel(...args);
      const group = groups[Number(picker.model.value)];
      const model = group?.ldsRenaultModel;
      const routes = model ? RENAULT_GENERATION_ROUTES.filter(route => route.model === model) : [];
      if (!routes.length) {
        selectedRouteKey = '';
        return result;
      }
      let restoredOption = null;
      routes.forEach(route => {
        const option = [...picker.generation.options].find(candidate => {
          try { return new URL(candidate.value, location.origin).searchParams.get('lds_generation') === route.key; }
          catch (_error) { return false; }
        });
        if (!option) return;
        option.textContent = route.generation + (route.years ? ' (' + route.years + ')' : '');
        option.dataset.ldsRenaultRoute = route.key;
        option.title = route.note;
        if (route.key === previousRouteKey) restoredOption = option;
      });
      if (restoredOption) {
        selectedRouteKey = previousRouteKey;
        picker.generation.value = restoredOption.value;
        picker.destination(restoredOption.value);
      }
      return result;
    };
  };


  const normalizeAccordProductId = value => String(value || '')
    .replace(/^gid:\/\/shopify\/Product\//i, '');
  const accordProductMatches = (product, route) => {
    if (!product || !route) return false;
    const id = normalizeAccordProductId(product.id);
    const idMatch = route.exactProductIds.some(expected =>
      normalizeAccordProductId(expected) === id);
    const handleMatch = route.exactHandles.includes(String(product.handle || '').trim());
    return idMatch || handleMatch;
  };
  const selectedHondaAccordRoute = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'honda') return null;
    const model = picker.model?.selectedOptions?.[0]?.textContent?.trim().toLowerCase();
    if (model !== 'accord') return null;
    const key = picker.generation?.selectedOptions?.[0]?.dataset?.ldsHondaAccordRoute || '';
    return HONDA_ACCORD_GENERATION_ROUTES.find(route => route.key === key) || null;
  };
  const scopeHondaAccordProducts = (products, route) => {
    if (!route) return products;
    const source = Array.isArray(products) ? products : [];
    const sills = source.filter(product => !product.isBadge && product.kind !== 'badge');
    const matched = sills.filter(product => accordProductMatches(product, route));
    if (matched.length !== route.exactProductIds.length) {
      throw new Error(`Exact ${route.label} products could not be verified`);
    }
    return source.filter(product =>
      product.isBadge || product.kind === 'badge' || accordProductMatches(product, route));
  };
  const addHondaAccordGenerationRoutes = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'honda') return;
    const group = (picker.groups || []).find(item =>
      String(item.label || '').trim().toLowerCase() === 'accord');
    if (!group?.parent) return;
    let selectedRouteKey = '';
    group.variants = HONDA_ACCORD_GENERATION_ROUTES.map(route => ({
      generation: route.generation, years: route.years,
      url: `${group.parent}?lds_generation=${encodeURIComponent(route.key)}`,
    }));
    picker.generation.addEventListener('change', () => {
      selectedRouteKey = picker.generation.selectedOptions?.[0]?.dataset?.ldsHondaAccordRoute || '';
    });
    const originalChooseModel = picker.chooseModel.bind(picker);
    picker.chooseModel = (...args) => {
      const previousRouteKey = selectedRouteKey
        || picker.generation?.selectedOptions?.[0]?.dataset?.ldsHondaAccordRoute || '';
      const result = originalChooseModel(...args);
      const model = picker.model?.selectedOptions?.[0]?.textContent?.trim().toLowerCase();
      if (model !== 'accord') {
        selectedRouteKey = '';
        return result;
      }
      if (!picker.generation) return result;
      const options = [...picker.generation.options]
        .filter(option => option.value.startsWith(`${group.parent}?lds_generation=`));
      let restoredOption = null;
      HONDA_ACCORD_GENERATION_ROUTES.forEach((route, index) => {
        const option = options[index];
        if (!option) return;
        option.textContent = route.generation;
        option.dataset.ldsHondaAccordRoute = route.key;
        option.title = route.note;
        if (route.key === previousRouteKey) restoredOption = option;
      });
      if (restoredOption) {
        selectedRouteKey = previousRouteKey;
        picker.generation.value = restoredOption.value;
        picker.destination(restoredOption.value);
      }
      return result;
    };
  };
  const normalizeHyundaiTucsonProductId = value => String(value || '')
    .replace(/^gid:\/\/shopify\/Product\//i, '');
  const hyundaiTucsonProductMatches = (product, route) => {
    if (!product || !route) return false;
    const id = normalizeHyundaiTucsonProductId(product.id);
    const idMatch = route.exactProductIds.some(expected =>
      normalizeHyundaiTucsonProductId(expected) === id);
    const handleMatch = route.exactHandles.includes(String(product.handle || '').trim());
    return idMatch || handleMatch;
  };
  const selectedHyundaiTucsonRoute = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'hyundai') return null;
    const model = picker.model?.selectedOptions?.[0]?.textContent?.trim().toLowerCase();
    if (model !== 'tucson') return null;
    const key = picker.generation?.selectedOptions?.[0]?.dataset?.ldsHyundaiTucsonRoute || '';
    return HYUNDAI_TUCSON_GENERATION_ROUTES.find(route => route.key === key) || null;
  };
  const scopeHyundaiTucsonProducts = (products, route) => {
    if (!route) return products;
    const source = Array.isArray(products) ? products : [];
    const sills = source.filter(product => !product.isBadge && product.kind !== 'badge');
    const matched = sills.filter(product => hyundaiTucsonProductMatches(product, route));
    if (matched.length !== route.exactProductIds.length) {
      throw new Error(`Exact ${route.label} products could not be verified`);
    }
    return source.filter(product =>
      product.isBadge || product.kind === 'badge' || hyundaiTucsonProductMatches(product, route));
  };
  const addHyundaiTucsonGenerationRoutes = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'hyundai') return;
    const group = (picker.groups || []).find(item =>
      String(item.label || '').trim().toLowerCase() === 'tucson');
    if (!group?.parent) return;
    let selectedRouteKey = '';
    group.variants = HYUNDAI_TUCSON_GENERATION_ROUTES.map(route => ({
      generation: route.generation, years: route.years,
      url: `${group.parent}?lds_generation=${encodeURIComponent(route.key)}`,
    }));
    picker.generation.addEventListener('change', () => {
      selectedRouteKey = picker.generation.selectedOptions?.[0]?.dataset?.ldsHyundaiTucsonRoute || '';
    });
    const originalChooseModel = picker.chooseModel.bind(picker);
    picker.chooseModel = (...args) => {
      const previousRouteKey = selectedRouteKey
        || picker.generation?.selectedOptions?.[0]?.dataset?.ldsHyundaiTucsonRoute || '';
      const result = originalChooseModel(...args);
      const model = picker.model?.selectedOptions?.[0]?.textContent?.trim().toLowerCase();
      if (model !== 'tucson') {
        selectedRouteKey = '';
        return result;
      }
      if (!picker.generation) return result;
      const options = [...picker.generation.options]
        .filter(option => option.value.startsWith(`${group.parent}?lds_generation=`));
      let restoredOption = null;
      HYUNDAI_TUCSON_GENERATION_ROUTES.forEach((route, index) => {
        const option = options[index];
        if (!option) return;
        option.textContent = route.generation;
        option.dataset.ldsHyundaiTucsonRoute = route.key;
        option.title = route.note;
        if (route.key === previousRouteKey) restoredOption = option;
      });
      if (restoredOption) {
        selectedRouteKey = previousRouteKey;
        picker.generation.value = restoredOption.value;
        picker.destination(restoredOption.value);
      }
      return result;
    };
  };
  const normalizeKiaSorentoProductId = value => String(value || '')
    .replace(/^gid:\/\/shopify\/Product\//i, '');
  const kiaSorentoProductMatches = (product, route) => {
    if (!product || !route) return false;
    const id = normalizeKiaSorentoProductId(product.id);
    const idMatch = route.exactProductIds.some(expected =>
      normalizeKiaSorentoProductId(expected) === id);
    const handleMatch = route.exactHandles.includes(String(product.handle || '').trim());
    return idMatch || handleMatch;
  };
  const selectedKiaSorentoRoute = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'kia') return null;
    const model = picker.model?.selectedOptions?.[0]?.textContent?.trim().toLowerCase();
    if (model !== 'sorento') return null;
    const key = picker.generation?.selectedOptions?.[0]?.dataset?.ldsKiaSorentoRoute || '';
    return KIA_SORENTO_GENERATION_ROUTES.find(route => route.key === key) || null;
  };
  const scopeKiaSorentoProducts = (products, route) => {
    if (!route) return products;
    const source = Array.isArray(products) ? products : [];
    const sills = source.filter(product => !product.isBadge && product.kind !== 'badge');
    const matched = sills.filter(product => kiaSorentoProductMatches(product, route));
    if (matched.length !== route.exactProductIds.length) {
      throw new Error(`Exact ${route.label} products could not be verified`);
    }
    return source.filter(product =>
      product.isBadge || product.kind === 'badge' || kiaSorentoProductMatches(product, route));
  };
  const addKiaSorentoGenerationRoutes = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'kia') return;
    const group = (picker.groups || []).find(item =>
      String(item.label || '').trim().toLowerCase() === 'sorento');
    if (!group?.parent) return;
    let selectedRouteKey = '';
    group.variants = KIA_SORENTO_GENERATION_ROUTES.map(route => ({
      generation: route.generation, years: route.years,
      url: `${group.parent}?lds_generation=${encodeURIComponent(route.key)}`,
    }));
    picker.generation.addEventListener('change', () => {
      selectedRouteKey = picker.generation.selectedOptions?.[0]?.dataset?.ldsKiaSorentoRoute || '';
    });
    const originalChooseModel = picker.chooseModel.bind(picker);
    picker.chooseModel = (...args) => {
      const previousRouteKey = selectedRouteKey
        || picker.generation?.selectedOptions?.[0]?.dataset?.ldsKiaSorentoRoute || '';
      const result = originalChooseModel(...args);
      const model = picker.model?.selectedOptions?.[0]?.textContent?.trim().toLowerCase();
      if (model !== 'sorento') {
        selectedRouteKey = '';
        return result;
      }
      if (!picker.generation) return result;
      const options = [...picker.generation.options]
        .filter(option => option.value.startsWith(`${group.parent}?lds_generation=`));
      let restoredOption = null;
      KIA_SORENTO_GENERATION_ROUTES.forEach((route, index) => {
        const option = options[index];
        if (!option) return;
        option.textContent = route.generation;
        option.dataset.ldsKiaSorentoRoute = route.key;
        option.title = route.note;
        if (route.key === previousRouteKey) restoredOption = option;
      });
      if (restoredOption) {
        selectedRouteKey = previousRouteKey;
        picker.generation.value = restoredOption.value;
        picker.destination(restoredOption.value);
      }
      return result;
    };
  };
  const normalizeMitsubishiOutlanderProductId = value => String(value || '')
    .replace(/^gid:\/\/shopify\/Product\//i, '');
  const mitsubishiOutlanderProductMatches = (product, route) => {
    if (!product || !route) return false;
    const id = normalizeMitsubishiOutlanderProductId(product.id);
    const idMatch = route.exactProductIds.some(expected =>
      normalizeMitsubishiOutlanderProductId(expected) === id);
    const handleMatch = route.exactHandles.includes(String(product.handle || '').trim());
    return idMatch || handleMatch;
  };
  const selectedMitsubishiOutlanderRoute = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'mitsubishi') return null;
    const model = picker.model?.selectedOptions?.[0]?.textContent?.trim().toLowerCase();
    if (model !== 'outlander') return null;
    const key = picker.generation?.selectedOptions?.[0]?.dataset?.ldsMitsubishiOutlanderRoute || '';
    return MITSUBISHI_OUTLANDER_GENERATION_ROUTES.find(route => route.key === key) || null;
  };
  const scopeMitsubishiOutlanderProducts = (products, route) => {
    if (!route) return products;
    const source = Array.isArray(products) ? products : [];
    const sills = source.filter(product => !product.isBadge && product.kind !== 'badge');
    const matched = sills.filter(product => mitsubishiOutlanderProductMatches(product, route));
    if (matched.length !== route.exactProductIds.length) {
      throw new Error(`Exact ${route.label} products could not be verified`);
    }
    return source.filter(product =>
      product.isBadge || product.kind === 'badge' || mitsubishiOutlanderProductMatches(product, route));
  };
  const addMitsubishiOutlanderGenerationRoutes = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'mitsubishi') return;
    const group = (picker.groups || []).find(item =>
      String(item.label || '').trim().toLowerCase() === 'outlander');
    if (!group?.parent) return;
    let selectedRouteKey = '';
    const existingVariants = Array.isArray(group.variants) ? group.variants : [];
    const routeVariants = MITSUBISHI_OUTLANDER_GENERATION_ROUTES.map(route => ({
      generation: route.generation, years: route.years,
      url: `${group.parent}?lds_generation=${encodeURIComponent(route.key)}`,
    }));
    const existingVariantUrls = new Set(existingVariants.map(row => String(row.url || '')));
    group.variants = existingVariants.concat(
      routeVariants.filter(row => !existingVariantUrls.has(String(row.url || ''))),
    );
    picker.generation.addEventListener('change', () => {
      selectedRouteKey = picker.generation.selectedOptions?.[0]?.dataset?.ldsMitsubishiOutlanderRoute || '';
    });
    const originalChooseModel = picker.chooseModel.bind(picker);
    picker.chooseModel = (...args) => {
      const previousRouteKey = selectedRouteKey
        || picker.generation?.selectedOptions?.[0]?.dataset?.ldsMitsubishiOutlanderRoute || '';
      const result = originalChooseModel(...args);
      const model = picker.model?.selectedOptions?.[0]?.textContent?.trim().toLowerCase();
      if (model !== 'outlander') {
        selectedRouteKey = '';
        return result;
      }
      if (!picker.generation) return result;
      const options = [...picker.generation.options]
        .filter(option => option.value.startsWith(`${group.parent}?lds_generation=`));
      let restoredOption = null;
      MITSUBISHI_OUTLANDER_GENERATION_ROUTES.forEach((route, index) => {
        const option = options[index];
        if (!option) return;
        option.textContent = route.generation;
        option.dataset.ldsMitsubishiOutlanderRoute = route.key;
        option.title = route.note;
        if (route.key === previousRouteKey) restoredOption = option;
      });
      if (restoredOption) {
        selectedRouteKey = previousRouteKey;
        picker.generation.value = restoredOption.value;
        picker.destination(restoredOption.value);
      }
      return result;
    };
  };
  const normalizeNissanMuranoProductId = value => String(value || '')
    .replace(/^gid:\/\/shopify\/Product\//i, '');
  const nissanMuranoProductMatches = (product, route) => {
    if (!product || !route) return false;
    const id = normalizeNissanMuranoProductId(product.id);
    const idMatch = route.exactProductIds.some(expected =>
      normalizeNissanMuranoProductId(expected) === id);
    const handleMatch = route.exactHandles.includes(String(product.handle || '').trim());
    return idMatch || handleMatch;
  };
  const selectedNissanMuranoRoute = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'nissan') return null;
    const model = picker.model?.selectedOptions?.[0]?.textContent?.trim().toLowerCase();
    if (model !== 'murano') return null;
    const key = picker.generation?.selectedOptions?.[0]?.dataset?.ldsNissanMuranoRoute || '';
    return NISSAN_MURANO_GENERATION_ROUTES.find(route => route.key === key) || null;
  };
  const selectedNissanMuranoModel = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'nissan') return false;
    return picker.model?.selectedOptions?.[0]?.textContent?.trim().toLowerCase() === 'murano';
  };
  const scopeNissanMuranoProducts = (products, route) => {
    if (!route) return products;
    const source = Array.isArray(products) ? products : [];
    const sills = source.filter(product => !product.isBadge && product.kind !== 'badge');
    const matched = sills.filter(product => nissanMuranoProductMatches(product, route));
    if (matched.length !== route.exactProductIds.length) {
      throw new Error(`Exact ${route.label} products could not be verified`);
    }
    // The Murano model collection is the only sill source for this route.
    // Do not carry any unrelated badge rows from a broader resolver result;
    // the exact MURANO design is added from the full badge collection below.
    return matched;
  };
  const addNissanMuranoGenerationRoutes = (picker, brand) => {
    if (String(brand || '').trim().toLowerCase() !== 'nissan') return;
    const groups = Array.isArray(picker.groups) ? picker.groups : [];
    let group = groups.find(item =>
      String(item.label || '').trim().toLowerCase() === 'murano');
    if (!group) {
      group = {label: 'Murano', parent: '/collections/nissan-murano-logo-door-sills', variants: []};
      picker.groups = [...groups, group];
      picker.model.add(new Option('Murano', String(picker.groups.length - 1)));
    } else {
      // Use the live four-product Murano collection as the model anchor;
      // the Nissan brand root contains unrelated models.
      group.parent = '/collections/nissan-murano-logo-door-sills';
    }
    let selectedRouteKey = '';
    const routeVariants = NISSAN_MURANO_GENERATION_ROUTES.map(route => ({
      generation: route.generation, years: route.years,
      url: `${group.parent}?lds_generation=${encodeURIComponent(route.key)}`,
    }));
    group.variants = routeVariants;
    picker.generation.addEventListener('change', () => {
      selectedRouteKey = picker.generation.selectedOptions?.[0]?.dataset?.ldsNissanMuranoRoute || '';
    });
    const originalChooseModel = picker.chooseModel.bind(picker);
    picker.chooseModel = (...args) => {
      const previousRouteKey = selectedRouteKey
        || picker.generation?.selectedOptions?.[0]?.dataset?.ldsNissanMuranoRoute || '';
      const result = originalChooseModel(...args);
      const model = picker.model?.selectedOptions?.[0]?.textContent?.trim().toLowerCase();
      if (model !== 'murano') {
        selectedRouteKey = '';
        return result;
      }
      if (!picker.generation) return result;
      const options = [...picker.generation.options]
        .filter(option => option.value.startsWith(`${group.parent}?lds_generation=`));
      let restoredOption = null;
      NISSAN_MURANO_GENERATION_ROUTES.forEach((route, index) => {
        const option = options[index];
        if (!option) return;
        option.textContent = route.generation;
        option.dataset.ldsNissanMuranoRoute = route.key;
        option.title = route.note;
        if (route.key === previousRouteKey) restoredOption = option;
      });
      if (restoredOption) {
        selectedRouteKey = previousRouteKey;
        picker.generation.value = restoredOption.value;
        picker.destination(restoredOption.value);
      }
      return result;
    };
  };
  const productId = product => String(product?.id || product?.handle || product?.url || product?.title || '');
  const designKey = product => String(product?.logoType || '')
    .normalize('NFKC')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
  const diverseProducts = (products, limit = 4) => {
    const source = Array.isArray(products) ? products : [];
    const selected = [];
    const selectedIds = new Set();
    const selectedDesigns = new Set();
    const add = product => {
      const id = productId(product);
      if (selectedIds.has(id)) return false;
      selectedIds.add(id);
      selected.push(product);
      return true;
    };
    source.forEach(product => {
      if (selected.length >= limit) return;
      const design = designKey(product);
      if (!design || selectedDesigns.has(design)) return;
      if (add(product)) selectedDesigns.add(design);
    });
    source.forEach(product => {
      if (selected.length >= limit) return;
      add(product);
    });
    return selected;
  };
  const partitionSills = (products, context) => {
    const partitions = {stainless: [], matte: [], unknown: []};
    products.forEach(product => { partitions[finishOf(product, context)].push(product); });
    return partitions;
  };
  const showingNote = (visible, total, suffix = '') =>
    `Showing ${visible} of ${total} products.${suffix ? ` ${suffix}` : ''}`;
  const featuredNote = (visible, suffix = '') =>
    `Showing ${visible} featured products.${suffix ? ` ${suffix}` : ''}`;
  const viewAllText = (label, total) =>
    `View all ${label}${Number.isFinite(total) ? ` (${total})` : ''} →`;
  async function card(product) {
    if (!cardCache.has(product.id)) {
      const url = localUrl(product.url);
      url.search = '';
      url.searchParams.set('section_id', 'lds-hub-product-source');
      const promise = fetch(url).then(async response => {
        if (!response.ok) throw new Error('Product preview unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const node = doc.querySelector('[data-lds-hub-product]');
        if (!node) throw new Error('Product preview unavailable');
        return node.outerHTML;
      }).catch(error => { cardCache.delete(product.id); throw error; });
      cardCache.set(product.id, promise);
    }
    return cardCache.get(product.id);
  }
  async function illustratedCards(products, limit = 4) {
    const ordered = diverseProducts(products, products.length);
    const selected = [];
    for (let offset = 0; offset < ordered.length && selected.length < limit;) {
      const batch = ordered.slice(offset, offset + limit - selected.length);
      offset += batch.length;
      const rendered = await Promise.all(batch.map(card));
      rendered.forEach(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        if (doc.querySelector('img[src], img[data-src]')) selected.push(html);
      });
    }
    return selected;
  }
  async function group({ title, products, limit = 4, total = products.length, link, linkText, note, empty, count = true }) {
    const featured = await illustratedCards(products, limit);
    const hasTotal = Number.isFinite(total);
    const section = el('div', 'lds-hub-filtered__group');
    const head = el('div', 'lds-hub-filtered__heading');
    head.append(el('h3', '', title + (count && hasTotal ? ` (${total})` : '')));
    section.append(head);
    const resolvedNote = typeof note === 'function' ? note(featured.length, total) : note;
    if (resolvedNote) section.append(el('p', 'lds-hub-filtered__note', resolvedNote));
    if (!featured.length) section.append(el('p', 'lds-hub-filtered__empty', products.length ? 'Product previews are unavailable. Browse the full collection below.' : empty));
    else {
      const grid = el('div', 'lds-hub-filtered__grid');
      grid.innerHTML = featured.join('');
      section.append(grid);
    }
    if (link && products.length) {
      const a = el('a', 'lds-hub-filtered__link', linkText);
      a.href = cleanLink(link);
      section.append(a);
    }
    return section;
  }
  const finishCountNodes = (hub, finish) => [...hub.querySelectorAll(`[data-hub-default-finish-count="${finish}"]`)];
  const finishLinkNodes = (hub, finish) => [...hub.querySelectorAll(`[data-hub-default-finish-link="${finish}"]`)];
  const setDefaultFinishLinks = (hub, picker, counts = {}) => {
    Object.entries(finishConfig).forEach(([finish, config]) => {
      finishLinkNodes(hub, finish).forEach(node => {
        node.href = cleanLink(finishUrl(picker.brand.value, config.tag));
        if (Number.isFinite(counts[finish])) node.textContent = viewAllText(config.title, counts[finish]);
      });
    });
  };
  const setDefaultFinishCount = (hub, finish, count) => {
    finishCountNodes(hub, finish).forEach(node => {
      const shown = hub.querySelector(`[data-hub-finish="${finish}"]`)?.querySelectorAll('[data-lds-hub-product]').length || 0;
      node.textContent = Number.isFinite(count) ? showingNote(shown, count) : 'Total unavailable';
    });
  };
  const badgeCountNodes = hub => [...hub.querySelectorAll('[data-hub-default-badge-count]')];
  const badgeGridNode = hub => hub.querySelector('[data-hub-default-badge-grid]');
  const badgeLinkNodes = hub => [...hub.querySelectorAll('[data-hub-default-badge-link]')];
  const setDefaultBadgeCount = (hub, count) => {
    badgeCountNodes(hub).forEach(node => {
      const shown = badgeGridNode(hub)?.querySelectorAll('[data-lds-hub-product]').length || 0;
      node.textContent = Number.isFinite(count) ? showingNote(shown, count) : 'Total unavailable';
    });
  };
  const setDefaultBadgeLink = (hub, link, count) => {
    if (!link) return;
    badgeLinkNodes(hub).forEach(node => {
      node.href = cleanLink(link);
      if (Number.isFinite(count)) node.textContent = viewAllText('designs', count);
    });
  };
  const badgeProducts = result => (result?.products || [])
    .filter(product => product.isBadge || product.kind === 'badge');
  const generalBadgeProducts = result => badgeProducts(result)
    .filter(product => !String(product.model || '').trim());
  // Parent-catalogue badge records are allowed here only by exact product ID
  // and exact hub badge collection path. This keeps the exception local to the
  // two hubs whose badge products intentionally retain another brand's model
  // metadata; it does not change the shared resolver or product metadata.
  const HUB_SCOPED_GENERAL_BADGE_ALLOWLISTS = Object.freeze({
    ram: Object.freeze({
      collectionPath: '/collections/ram-led-license-plate-badges',
      productIds: Object.freeze([
        '10320909304027', '10320912941275', '10320906322139',
        '10320886202587', '10321052008667',
      ]),
    }),
    rangerover: Object.freeze({
      collectionPath: '/collections/range-rover-led-license-plate-badges',
      productIds: Object.freeze(['10324581581019', '10324587282651']),
    }),
    suzuki: Object.freeze({
      collectionPath: '/collections/suzuki-led-license-plate-badges',
      productIds: Object.freeze(['10325894004955', '10325893382363', '10325893054683']),
    }),
    haval: Object.freeze({
      collectionPath: '/collections/haval-led-license-plate-badges',
      productIds: Object.freeze(['10323837649115', '10323860390107']),
    }),
    ssangyong: Object.freeze({
      collectionPath: '/collections/ssangyong-led-license-plate-badges',
      productIds: Object.freeze(['10325888434395', '10325888696539', '10325888762075']),
    }),
    vauxhall: Object.freeze({
      collectionPath: '/collections/vauxhall-led-license-plate-badges',
      productIds: Object.freeze(['10325945712859', '10325946269915', '10325945942235']),
    }),
  });
  const normalizeHubBadgeProductId = value => String(value || '')
    .replace(/^gid:\/\/shopify\/Product\//i, '');
  const normalizeHubBadgePath = value => {
    try {
      return localUrl(value).pathname.replace(/\/$/, '').toLowerCase();
    } catch (_error) {
      return '';
    }
  };
  const scopedGeneralBadgeProducts = (result, brand, collectionUrl) => {
    const key = String(brand || '').normalize('NFKC').toLowerCase().replace(/[^a-z0-9]+/g, '');
    const rule = HUB_SCOPED_GENERAL_BADGE_ALLOWLISTS[key];
    const path = normalizeHubBadgePath(result?.collectionUrl || collectionUrl);
    if (!rule || path !== rule.collectionPath) return generalBadgeProducts(result);
    const allowed = new Set(rule.productIds);
    return badgeProducts(result).filter(product => allowed.has(normalizeHubBadgeProductId(product.id)));
  };
  const renderGrid = async (grid, products) => {
    if (!grid) return null;
    const html = await illustratedCards(products, 4);
    return {grid, html: html.join('')};
  };
  const commitGrids = rendered => rendered.filter(Boolean).forEach(({grid, html}) => { grid.innerHTML = html; });
  const resolveFullBadgeCollection = async (url, signal) => {
    if (!url || !window.LdsSearchEngine?.resolve) return null;
    try {
      const result = await window.LdsSearchEngine.resolve({collectionUrl: url, signal});
      return result.complete ? result : null;
    } catch (error) {
      if (error.name === 'AbortError') throw error;
      return null;
    }
  };
  async function updateDefaultFinishCounts(hub, picker) {
    const source = picker.brand?.value?.trim();
    if (!source || !window.LdsSearchEngine?.resolve) {
      Object.keys(finishConfig).forEach(finish => setDefaultFinishCount(hub, finish, NaN));
      setDefaultBadgeCount(hub, NaN);
      return;
    }
    try {
      const result = await window.LdsSearchEngine.resolve({collectionUrl: source});
      if (!result.complete) throw new Error('Incomplete default catalogue results');
      const materialContext = {
        brand: hubBrand(hub),
        collectionUrl: result.collectionUrl || source,
      };
      const partitions = partitionSills((result.products || [])
        .filter(product => !product.isBadge && product.kind !== 'badge'), materialContext);
      const badgeResult = await resolveFullBadgeCollection(hub.dataset.hubBadgeCollection || result.badgeCollectionUrl);
      const finishGrids = Object.keys(finishConfig).map(finish => ({
        grid: hub.querySelector(`[data-hub-finish="${finish}"]`),
        products: partitions[finish],
      })).filter(entry => entry.grid);
      const renderedFinishes = await Promise.all(finishGrids.map(entry => renderGrid(entry.grid, entry.products)));
      const badgeGrid = badgeGridNode(hub);
      const renderedBadge = badgeGrid && badgeResult
        ? await renderGrid(badgeGrid, badgeProducts(badgeResult))
        : null;
      commitGrids([...renderedFinishes, renderedBadge]);
      Object.keys(finishConfig).forEach(finish => setDefaultFinishCount(hub, finish, partitions[finish].length));
      const defaultBadgeTotal = badgeResult ? badgeProducts(badgeResult).length : NaN;
      setDefaultBadgeCount(hub, defaultBadgeTotal);
      setDefaultFinishLinks(hub, picker, Object.fromEntries(Object.entries(partitions).map(([finish, products]) => [finish, products.length])));
      setDefaultBadgeLink(hub, hub.dataset.hubBadgeCollection || result.badgeCollectionUrl, defaultBadgeTotal);
      if (renderedFinishes.some(Boolean) || renderedBadge) {
        window.__LDS_STAINLESS_COVER_REFRESH__?.();
        window.__LDS_MATTE_COVER_REFRESH__?.();
      }
    } catch (_error) {
      Object.keys(finishConfig).forEach(finish => setDefaultFinishCount(hub, finish, NaN));
      setDefaultBadgeCount(hub, NaN);
    }
  }
  async function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const hub = root.closest('[data-lds-accessories-hub]');
    const picker = root.querySelector('[data-hub-native-picker]');
    const input = root.querySelector('[data-hub-model-input]');
    const list = root.querySelector('[data-hub-model-list]');
    const status = root.querySelector('[data-hub-results-status]');
    const summary = root.querySelector('[data-hub-selected]');
    if (!hub || !picker || !input || !list || !status || !summary) return;
    const defaultSills = hub.querySelector('[data-hub-default-sills]');
    const defaultBadges = hub.querySelector('[data-hub-default-badges]');
    const filteredSills = hub.querySelector('[data-hub-filtered-sills]');
    const filteredBadges = hub.querySelector('[data-hub-filtered-badges]');
    const defaults = [defaultSills, defaultBadges].filter(Boolean);
    const outputs = [filteredSills, filteredBadges].filter(Boolean);
    const brand = hubBrand(hub);
    let revision = 0;
    let controller;
    let busy = false;
    await customElements.whenDefined('lds-search-vehicle');
    await picker.load();
    addHondaAccordGenerationRoutes(picker, brand);
    addHyundaiTucsonGenerationRoutes(picker, brand);
    addKiaSorentoGenerationRoutes(picker, brand);
    addMitsubishiOutlanderGenerationRoutes(picker, brand);
    addNissanMuranoGenerationRoutes(picker, brand);
    addPeugeot3008GenerationRoutes(picker, brand);
    addSubaruForesterGenerationRoutes(picker, brand);
    addPorscheCayenneGenerationRoutes(picker, brand);
    addRenaultGenerationRoutes(picker, brand);
    addSuzukiGenerationRoutes(picker, brand);
    // Add confirmed grille-design model routes absent from the sill picker.
    // These selections render grille badges only, without asserting sill fit.
    const grilleModels = new Set();
    hub.querySelectorAll('[data-grille-badge-routing]').forEach(card => {
      try {
        const routing = JSON.parse(card.dataset.grilleBadgeRouting);
        if (routing.scope === 'model') (routing.modelTokens || []).forEach(model => {
          if (typeof model === 'string' && model.trim()) grilleModels.add(model.trim());
        });
      } catch (_error) { /* Invalid routing never creates a model. */ }
    });
    grilleModels.forEach(label => {
      if ((picker.groups || []).some(group => group.label.toLowerCase() === label.toLowerCase())) return;
      const index = picker.groups.length;
      picker.groups.push({label, parent: location.pathname, variants: [], grilleOnly: true});
      picker.model.add(new Option(label, String(index)));
    });
    const groups = picker.groups || [];
    const selectionContext = hubSelectionContext(hub, picker, brand);
    const selectionStorageKey = hubSelectionStorageKey(selectionContext);
    const modelControl = input.closest('[data-hub-model-combobox]') || input.parentElement;
    let modelOptions = [];
    let activeModelIndex = -1;
    let modelListOpen = false;
    const optionId = index => `${list.id}-option-${index}`;
    const setActiveModel = index => {
      activeModelIndex = index >= 0 && index < modelOptions.length ? index : -1;
      modelOptions.forEach((option, optionIndex) => {
        option.setAttribute('aria-selected', optionIndex === activeModelIndex ? 'true' : 'false');
      });
      const activeOption = modelOptions[activeModelIndex];
      if (activeOption) {
        input.setAttribute('aria-activedescendant', activeOption.id);
        activeOption.scrollIntoView?.({block: 'nearest'});
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    };
    const renderModelOptions = () => {
      const query = input.value.trim().toLowerCase();
      const matches = groups
        .map((group, index) => ({group, index}))
        .filter(({group}) => group.label.toLowerCase().includes(query));
      list.replaceChildren();
      modelOptions = matches.map(({group, index}) => {
        const option = document.createElement('div');
        option.id = optionId(index);
        option.className = 'lds-hub-vehicle__model-option';
        option.dataset.modelIndex = String(index);
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', 'false');
        option.tabIndex = -1;
        option.textContent = group.label;
        list.append(option);
        return option;
      });
      if (!modelOptions.length) {
        const empty = document.createElement('div');
        empty.className = 'lds-hub-vehicle__model-empty';
        empty.setAttribute('role', 'status');
        empty.textContent = 'No matching models';
        list.append(empty);
      }
      setActiveModel(-1);
    };
    const closeModelOptions = () => {
      modelListOpen = false;
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      setActiveModel(-1);
    };
    const openModelOptions = () => {
      renderModelOptions();
      modelListOpen = true;
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };
    setDefaultFinishLinks(hub, picker);
    updateDefaultFinishCounts(hub, picker);
    input.disabled = !groups.length;
    if (!groups.length) {
      status.textContent = 'Models could not load. Reload this page to retry.';
      return;
    }
    const choose = () => {
      const index = groups.findIndex(g => g.label.toLowerCase() === input.value.trim().toLowerCase());
      const nextModel = index < 0 ? '' : String(index);
      // Native change may follow input/option selection on blur. Preserve an
      // already selected generation when the model itself has not changed.
      if (picker.model.value !== nextModel) {
        picker.model.value = nextModel;
        picker.chooseModel();
      }
      input.setCustomValidity(index < 0 && input.value ? `Choose an available ${brand} model.` : '');
      if (busy) {
        ++revision;
        controller?.abort();
        busy = false; root.removeAttribute('aria-busy');
        status.textContent = 'Selection changed. Choose Show accessories to update the results.';
      }
    };
    const persistSelection = () => {
      if (!picker.target) return;
      const modelIndex = Number(picker.model?.value);
      const group = Number.isInteger(modelIndex) ? groups[modelIndex] : null;
      const modelOption = picker.model?.selectedOptions?.[0];
      if (!group || !modelOption?.value) return;
      const generationOption = picker.generation?.selectedOptions?.[0];
      const generationValue = String(generationOption?.value || '').trim();
      if (generationValue && ![...(picker.generation?.options || [])]
        .some(option => selectionDestination(option.value) === selectionDestination(generationValue))) return;
      writeHubSelection(selectionStorageKey, {
        ...selectionContext,
        model: modelOption.textContent.trim(),
        generation: generationValue ? (generationOption?.textContent?.trim() || '') : '',
        generationValue,
      });
    };
    const restoreSelection = () => {
      const saved = readHubSelection(selectionStorageKey);
      if (!saved) return false;
      if (!String(saved.theme || '').trim() || !String(saved.brand || '').trim() || !String(saved.path || '').trim()
        || selectionText(saved.theme) !== selectionText(selectionContext.theme)
        || selectionText(saved.brand) !== selectionText(selectionContext.brand)
        || selectionPath(saved.path) !== selectionPath(selectionContext.path)) {
        clearHubSelection(selectionStorageKey);
        return false;
      }
      const modelLabel = String(saved.model || '').trim();
      const modelIndex = groups.findIndex(group => selectionText(group.label) === selectionText(modelLabel));
      if (modelIndex < 0) {
        clearHubSelection(selectionStorageKey);
        return false;
      }
      const group = groups[modelIndex];
      const variants = Array.isArray(group.variants) ? group.variants : [];
      const hasGeneration = Boolean(String(saved.generationValue || '').trim() || String(saved.generation || '').trim());
      const generationMatches = variants.some(variant => selectionGenerationMatches(variant, saved))
        || (group.parent && selectionGenerationMatches({url: group.parent, generation: 'All generations'}, saved));
      if (hasGeneration
        ? !generationMatches
        : variants.length > 0) {
        clearHubSelection(selectionStorageKey);
        return false;
      }
      input.value = group.label;
      choose();
      if (hasGeneration) {
        const savedValue = String(saved.generationValue || '').trim();
        const generationOption = [...(picker.generation?.options || [])].find(option => savedValue
          ? selectionDestination(option.value) === selectionDestination(savedValue)
          : selectionGenerationText(option.textContent) === selectionGenerationText(saved.generation));
        if (!generationOption) {
          clearHubSelection(selectionStorageKey);
          return false;
        }
        picker.generation.value = generationOption.value;
        picker.generation.dispatchEvent(new Event('change', {bubbles: true}));
      }
      return picker.model.value === String(modelIndex) && Boolean(picker.target);
    };
    const selectModelOption = optionIndex => {
      const option = modelOptions[optionIndex];
      const groupIndex = Number(option?.dataset.modelIndex);
      if (!Number.isInteger(groupIndex) || !groups[groupIndex]) return;
      input.value = groups[groupIndex].label;
      choose();
      input.focus({preventScroll: true});
      closeModelOptions();
    };
    input.addEventListener('focus', openModelOptions);
    input.addEventListener('input', () => {
      choose();
      openModelOptions();
    });
    input.addEventListener('change', choose);
    input.addEventListener('blur', () => {
      window.setTimeout(() => {
        if (!modelControl?.contains(document.activeElement)) closeModelOptions();
      }, 0);
    });
    list.addEventListener('pointerdown', event => {
      // Keep mouse focus on the input; touch gestures must remain scrollable.
      if (event.pointerType === 'mouse' && event.target.closest?.('[role="option"]')) event.preventDefault();
    });
    list.addEventListener('click', event => {
      const option = event.target.closest?.('[role="option"]');
      if (option) selectModelOption(modelOptions.indexOf(option));
    });
    document.addEventListener('pointerdown', event => {
      if (modelListOpen && !modelControl?.contains(event.target)) closeModelOptions();
    });
    picker.generation.addEventListener('change', () => {
      if (busy) {
        ++revision;
        controller?.abort();
        busy = false; root.removeAttribute('aria-busy');
        status.textContent = 'Selection changed. Choose Show accessories to update the results.';
      }
    });
    input.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (!modelListOpen) openModelOptions();
        if (!modelOptions.length) return;
        const offset = event.key === 'ArrowDown' ? 1 : -1;
        const nextIndex = activeModelIndex < 0
          ? (offset > 0 ? 0 : modelOptions.length - 1)
          : (activeModelIndex + offset + modelOptions.length) % modelOptions.length;
        setActiveModel(nextIndex);
        return;
      }
      if (event.key === 'Escape') {
        if (modelListOpen) {
          event.preventDefault();
          closeModelOptions();
        }
        return;
      }
      if (event.key === 'Enter') {
        if (modelListOpen && activeModelIndex >= 0) {
          event.preventDefault();
          selectModelOption(activeModelIndex);
        } else if (!picker.go.disabled) {
          event.preventDefault();
          closeModelOptions();
          picker.go.click();
        }
      }
    });
    root.querySelector('[data-hub-change]').addEventListener('click', () => {
      input.focus(); input.select(); root.scrollIntoView({block:'center', behavior:'smooth'});
    });
    root.querySelector('[data-hub-reset]').addEventListener('click', () => {
      ++revision; controller?.abort(); busy = false; root.removeAttribute('aria-busy');
      clearHubSelection(selectionStorageKey);
      input.value = ''; input.setCustomValidity(''); picker.model.value = ''; picker.chooseModel();
      summary.hidden = true; status.textContent = '';
      defaults.forEach(node => { node.hidden = false; });
      outputs.forEach(node => { node.hidden = true; node.replaceChildren(); });
      hub.removeAttribute('data-hub-filtered');
      input.focus();
    });
    picker.go.addEventListener('click', async event => {
      event.preventDefault(); event.stopImmediatePropagation();
      if (!picker.target || busy || !input.reportValidity()) return;
      const selectedGroup = groups[Number(picker.model.value)];
      if (selectedGroup?.grilleOnly) {
        ++revision; controller?.abort(); busy = false;
        root.removeAttribute('aria-busy');
        outputs.forEach(node => { node.replaceChildren(); node.hidden = false; });
        defaults.forEach(node => { node.hidden = true; });
        hub.dataset.hubFiltered = 'true';
        root.querySelector('[data-hub-selected-label]').textContent = selectedGroup.label;
        summary.hidden = false;
        status.textContent = '';
        persistSelection();
        hub.dispatchEvent(new CustomEvent('shopify:section:load', {bubbles: true}));
        return;
      }
      const version = ++revision;
      controller?.abort(); controller = new AbortController();
      busy = true; picker.go.disabled = true;
      status.textContent = `Finding accessories for your ${brand}…`;
      root.setAttribute('aria-busy', 'true');
      try {
        const result = await window.LdsSearchEngine.resolve({collectionUrl: picker.target, signal: controller.signal});
        if (version !== revision) return;
        if (!result.complete) throw new Error('Incomplete vehicle results');
        const accordRoute = selectedHondaAccordRoute(picker, brand);
        const tucsonRoute = selectedHyundaiTucsonRoute(picker, brand);
        const kiaSorentoRoute = selectedKiaSorentoRoute(picker, brand);
        const mitsubishiOutlanderRoute = selectedMitsubishiOutlanderRoute(picker, brand);
        const nissanMuranoRoute = selectedNissanMuranoRoute(picker, brand);
        const nissanMuranoModel = selectedNissanMuranoModel(picker, brand);
        const peugeot3008Route = selectedPeugeot3008Route(picker, brand);
        const peugeot3008Model = selectedPeugeot3008Model(picker, brand);
        const subaruForesterRoute = selectedSubaruForesterRoute(picker, brand);
        const subaruForesterModel = selectedSubaruForesterModel(picker, brand);
        const porscheCayenneRoute = selectedPorscheCayenneRoute(picker, brand);
        const renaultRoutes = selectedRenaultRoutes(picker, brand);
        const renaultRoute = renaultRoutes?.length === 1 ? renaultRoutes[0] : null;
        const renaultModelKey = selectedRenaultModelKey(picker, brand);
        const suzukiRoute = selectedSuzukiRoute(picker, brand);
        const finalFourRoute = selectedFinalFourRoute(picker, brand);
        const selectedRoute = finalFourRoute || accordRoute || tucsonRoute || kiaSorentoRoute || mitsubishiOutlanderRoute || nissanMuranoRoute || peugeot3008Route || subaruForesterRoute || porscheCayenneRoute || renaultRoute || suzukiRoute;
        // Keep model-level badges intact; scope only non-badge sill products.
        const scopedProducts = finalFourRoute
          ? scopeFinalFourProducts(result.products, finalFourRoute)
          : accordRoute
          ? scopeHondaAccordProducts(result.products, accordRoute)
          : tucsonRoute
            ? scopeHyundaiTucsonProducts(result.products, tucsonRoute)
            : kiaSorentoRoute
              ? scopeKiaSorentoProducts(result.products, kiaSorentoRoute)
              : mitsubishiOutlanderRoute
                ? scopeMitsubishiOutlanderProducts(result.products, mitsubishiOutlanderRoute)
                : nissanMuranoRoute
                  ? scopeNissanMuranoProducts(result.products, nissanMuranoRoute)
                  : peugeot3008Model
                    ? scopePeugeot3008Products(result.products, peugeot3008Route)
                    : subaruForesterModel
                      ? scopeSubaruForesterProducts(result.products, subaruForesterRoute)
                      : porscheCayenneRoute
                        ? scopePorscheCayenneProducts(result.products, porscheCayenneRoute)
                      : renaultRoutes
                        ? scopeRenaultProducts(result.products, renaultRoutes)
                        : suzukiRoute
                          ? scopeSuzukiProducts(result.products, suzukiRoute)
                          : result.products;
        const sills = scopedProducts.filter(p => !p.isBadge && p.kind !== 'badge');
        const finishGroups = partitionSills(sills, {
          brand,
          collectionUrl: result.collectionUrl || picker.target,
        });
        const badgeEnabled = Boolean(defaultBadges || filteredBadges);
        const fullBadgeResult = badgeEnabled
          ? await resolveFullBadgeCollection(hub.dataset.hubBadgeCollection || result.badgeCollectionUrl, controller.signal)
          : null;
        const routeBadgeProducts = finalFourRoute?.queryParam === 'lds_verified_model'
          ? result.products.filter(product => (product.isBadge || product.kind === 'badge')
            && (product.badgeEvidence === 'model' || product.badgeEvidence === 'generation'))
          : (nissanMuranoModel || peugeot3008Model || subaruForesterModel || suzukiRoute || (finalFourRoute && finalFourRoute.exactModelBadgeIds.length)) && fullBadgeResult
          ? badgeProducts(fullBadgeResult)
            .filter(product => {
              const routes = nissanMuranoModel
                ? NISSAN_MURANO_GENERATION_ROUTES
                : peugeot3008Route ? [peugeot3008Route]
                  : subaruForesterModel
                    ? (subaruForesterRoute ? [subaruForesterRoute] : SUBARU_FORESTER_GENERATION_ROUTES)
                    : suzukiRoute
                      ? [suzukiRoute]
                      : finalFourRoute
                        ? [finalFourRoute]
                      : PEUGEOT_3008_GENERATION_ROUTES;
              return routes.some(route => route.exactModelBadgeIds
                .some(expected => normalizePeugeot3008ProductId(expected) === normalizePeugeot3008ProductId(product.id)));
            })
            .map(product => ({...product, badgeEvidence: 'model'}))
          : [];
        const badges = [...(finalFourRoute || nissanMuranoModel || peugeot3008Model || subaruForesterModel || suzukiRoute ? [] : scopedProducts.filter(product =>
          (product.isBadge || product.kind === 'badge') && !isRenaultGeneralBadge(product, brand))), ...routeBadgeProducts]
          .filter((product, index, source) => source.findIndex(other => productId(other) === productId(product)) === index);
        const routeBadgeIds = new Set(routeBadgeProducts.map(product => productId(product)));
        const generalProducts = fullBadgeResult
          ? scopedGeneralBadgeProducts(
            fullBadgeResult,
            brand,
            hub.dataset.hubBadgeCollection || result.badgeCollectionUrl,
          ).filter(product => !routeBadgeIds.has(productId(product)))
          : result.logos;
        const generalTotal = fullBadgeResult ? generalProducts.length : NaN;
        let vehicle = selectedRoute?.label
          || (peugeot3008Model ? 'Peugeot 3008 (T84 / 3008 I and P84 / 3008 II)'
            : renaultModelKey ? `Renault ${RENAULT_MODEL_LABELS[renaultModelKey]}`
              : result.vehicleLabel || `${brand} ${input.value}`);
        if (brand === 'Mercedes') vehicle = vehicle.replace(/^(?:Mercedes-Benz\s+)?Mercedes\s+/, 'Mercedes ');
        const selectionNote = selectedRoute?.note || `For ${vehicle}. Confirm the model and years on the product page.`;
        const full = localUrl(result.collectionUrl || picker.target);
        full.searchParams.set('view', 'lds-vehicle-products');
        const exactPickerRoute = isExactPickerRoute(full.href);
        const finishPromises = Object.entries(finishConfig).map(([finish, config]) => {
          if (!hub.querySelector(`[data-hub-finish-panel="${finish}"]`)) return Promise.resolve(null);
          const products = finishGroups[finish];
          return group({
            title: config.title,
            products,
            limit: 4,
            total: products.length,
            link: exactPickerRoute && products.length <= 4 ? null : (selectedRoute ? null : finishUrl(full.href, config.tag)),
            linkText: viewAllText(config.title, products.length),
            note: (shown, total) => showingNote(shown, total, selectionNote),
            empty: config.unavailable,
          });
        });
        const unknownPromise = finishGroups.unknown.length
          ? group({
            title: 'Material unavailable',
            products: finishGroups.unknown,
            limit: 4,
            total: finishGroups.unknown.length,
            note: (shown, total) => showingNote(shown, total, 'The rendered source card did not identify Stainless Steel or Matte PRO.'),
            empty: 'No products with an unavailable material label are listed for this vehicle.',
          })
          : Promise.resolve(null);
        const [stainlessGroup, matteGroup, unknownGroup, badgeGroup, brandGroup] = await Promise.all([
          ...finishPromises,
          unknownPromise,
          badgeEnabled ? group({
            title:'License Plate Badges',
            products:badges,
            limit:4,
            total:badges.length,
            link:full.href,
            linkText:viewAllText('License Plate Badges', badges.length),
            note:(shown, total) => showingNote(shown, total, `Designs for ${vehicle}. Artwork matches the model name; it does not confirm mounting fit. Check plate dimensions and mounting on the product page.`),
            empty:'No model-specific badge designs are listed for this vehicle.',
          }) : Promise.resolve(null),
          badgeEnabled ? group({
            title:`General ${brand} designs`,
            products:generalProducts,
            limit:4,
            total:generalTotal,
            link:hub.dataset.hubBadgeCollection || result.badgeCollectionUrl,
            linkText:viewAllText(`${brand} designs`, fullBadgeResult ? badgeProducts(fullBadgeResult).length : NaN),
            note:(shown, total) => Number.isFinite(total)
              ? showingNote(shown, total, 'Brand artwork, shown separately from model designs. Check plate size and mounting.')
              : featuredNote(shown, 'Brand artwork, shown separately from model designs. Check plate size and mounting.'),
            empty:'No general brand designs are available.',
            count:Number.isFinite(generalTotal),
          }) : Promise.resolve(null)
        ]);
        if (version !== revision) return;
        const sillGroups = [stainlessGroup, matteGroup, unknownGroup].filter(Boolean);
        if (filteredSills) filteredSills.replaceChildren(...sillGroups);
        if (filteredBadges) filteredBadges.replaceChildren(...[badgeGroup, brandGroup].filter(Boolean));
        defaults.forEach(node => { node.hidden = true; });
        outputs.forEach(node => { node.hidden = false; });
        hub.dataset.hubFiltered = 'true';
        root.querySelector('[data-hub-selected-label]').textContent = vehicle;
        summary.hidden = false;
        const statusParts = [];
        if (defaultSills || filteredSills) {
          statusParts.push(`${finishGroups.stainless.length} Stainless Steel`, `${finishGroups.matte.length} Matte PRO`);
        }
        if (badgeEnabled) statusParts.push(`${badges.length} model badge designs`);
        status.textContent = statusParts.length
          ? `${statusParts.join(' · ')}. Full catalogue counts; featured products below.`
          : 'No enabled accessory categories returned for this brand.';
        hub.dispatchEvent(new CustomEvent('shopify:section:load', {bubbles:true}));
        window.__LDS_STAINLESS_COVER_REFRESH__?.();
        window.__LDS_MATTE_COVER_REFRESH__?.();
        persistSelection();
      } catch (error) {
        if (version === revision && error.name !== 'AbortError') status.textContent = 'Accessories could not load completely. Your previous selection is unchanged. Press Show accessories to retry.';
      } finally {
        if (version === revision) { busy = false; picker.go.disabled = !picker.target; root.removeAttribute('aria-busy'); }
      }
    }, true);
    const restored = restoreSelection();
    if (restored) {
      const restoredModel = picker.model.value;
      const restoredGeneration = picker.generation.value;
      window.setTimeout(() => {
        if (!busy && picker.model.value === restoredModel && picker.generation.value === restoredGeneration
          && picker.target && !picker.go.disabled) picker.go.click();
      }, 0);
    }
  }
  const boot = () => document.querySelectorAll('[data-hub-vehicle]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

